// src/data/database.ts

export interface IVocabulary {
  id: number;
  thai: string;
  vietnamese: string;
  pronunciation: string; // Phiên âm Latin/Việt giả lập
  category: string;
}

export interface IConversation {
  id: number;
  speaker: string;
  thai: string;
  vietnamese: string;
  role: "A" | "B";
  scenario?: string; // Thêm trường này để dễ phân loại ngữ cảnh nếu cần sau này
}

export const vocabularies: IVocabulary[] = [
  // --- CHÀO HỎI & CƠ BẢN ---
  {
    id: 1,
    thai: "สวัสดี",
    vietnamese: "Xin chào",
    pronunciation: "Sa-wat-dee",
    category: "Chào hỏi",
  },
  {
    id: 2,
    thai: "ขอบคุณ",
    vietnamese: "Cảm ơn",
    pronunciation: "Khop-khun",
    category: "Chào hỏi",
  },
  {
    id: 3,
    thai: "ขอโทษ",
    vietnamese: "Xin lỗi",
    pronunciation: "Khỏ-thốt",
    category: "Chào hỏi",
  },
  {
    id: 4,
    thai: "ไม่เป็นไร",
    vietnamese: "Không sao / Không có chi",
    pronunciation: "Mai-pen-rai",
    category: "Chào hỏi",
  },
  {
    id: 5,
    thai: "ใช่",
    vietnamese: "Đúng / Phải",
    pronunciation: "Chai",
    category: "Cơ bản",
  },
  {
    id: 6,
    thai: "ไม่",
    vietnamese: "Không",
    pronunciation: "Mai",
    category: "Cơ bản",
  },
  {
    id: 7,
    thai: "ฉัน / ผม",
    vietnamese: "Tôi (Nữ / Nam)",
    pronunciation: "Chắn / Phổm",
    category: "Đại từ",
  },
  {
    id: 8,
    thai: "คุณ",
    vietnamese: "Bạn / Ông / Bà",
    pronunciation: "Khun",
    category: "Đại từ",
  },

  // --- SỐ ĐẾM ---
  {
    id: 9,
    thai: "หนึ่ง",
    vietnamese: "Một",
    pronunciation: "Nừng",
    category: "Số đếm",
  },
  {
    id: 10,
    thai: "สอง",
    vietnamese: "Hai",
    pronunciation: "Sỏng",
    category: "Số đếm",
  },
  {
    id: 11,
    thai: "สาม",
    vietnamese: "Ba",
    pronunciation: "Sảm",
    category: "Số đếm",
  },
  {
    id: 12,
    thai: "สี่",
    vietnamese: "Bốn",
    pronunciation: "Sì",
    category: "Số đếm",
  },
  {
    id: 13,
    thai: "ห้า",
    vietnamese: "Năm",
    pronunciation: "Hả",
    category: "Số đếm",
  },
  {
    id: 14,
    thai: "หก",
    vietnamese: "Sáu",
    pronunciation: "Hộc",
    category: "Số đếm",
  },
  {
    id: 15,
    thai: "เจ็ด",
    vietnamese: "Bảy",
    pronunciation: "Chết",
    category: "Số đếm",
  },
  {
    id: 16,
    thai: "แปด",
    vietnamese: "Tám",
    pronunciation: "Pẹt",
    category: "Số đếm",
  },
  {
    id: 17,
    thai: "เก้า",
    vietnamese: "Chín",
    pronunciation: "Kao",
    category: "Số đếm",
  },
  {
    id: 18,
    thai: "สิบ",
    vietnamese: "Mười",
    pronunciation: "Sịp",
    category: "Số đếm",
  },

  // --- ĂN UỐNG ---
  {
    id: 19,
    thai: "กินข้าว",
    vietnamese: "Ăn cơm",
    pronunciation: "Kin-khao",
    category: "Động từ",
  },
  {
    id: 20,
    thai: "อร่อย",
    vietnamese: "Ngon",
    pronunciation: "A-roi",
    category: "Tính từ",
  },
  {
    id: 21,
    thai: "หิว",
    vietnamese: "Đói",
    pronunciation: "Hỉu",
    category: "Tính từ",
  },
  {
    id: 22,
    thai: "อิ่ม",
    vietnamese: "No",
    pronunciation: "Im",
    category: "Tính từ",
  },
  {
    id: 23,
    thai: "น้ำเปล่า",
    vietnamese: "Nước lọc",
    pronunciation: "Nam-plao",
    category: "Đồ uống",
  },
  {
    id: 24,
    thai: "กาแฟ",
    vietnamese: "Cà phê",
    pronunciation: "Ka-fe",
    category: "Đồ uống",
  },
  {
    id: 25,
    thai: "เผ็ด",
    vietnamese: "Cay",
    pronunciation: "Phệt",
    category: "Vị giác",
  },
  {
    id: 26,
    thai: "หวาน",
    vietnamese: "Ngọt",
    pronunciation: "Vản",
    category: "Vị giác",
  },
  {
    id: 27,
    thai: "ไก่",
    vietnamese: "Gà",
    pronunciation: "Kày",
    category: "Thực phẩm",
  },
  {
    id: 28,
    thai: "หมู",
    vietnamese: "Heo",
    pronunciation: "Mủ",
    category: "Thực phẩm",
  },
  {
    id: 29,
    thai: "เก็บเงิน",
    vietnamese: "Tính tiền",
    pronunciation: "Kẹp-ngân",
    category: "Nhà hàng",
  },

  // --- DU LỊCH & ĐỊA ĐIỂM ---
  {
    id: 30,
    thai: "ห้องน้ำ",
    vietnamese: "Nhà vệ sinh",
    pronunciation: "Hoọng-nám",
    category: "Địa điểm",
  },
  {
    id: 31,
    thai: "โรงแรม",
    vietnamese: "Khách sạn",
    pronunciation: "Rông-rem",
    category: "Địa điểm",
  },
  {
    id: 32,
    thai: "สนามบิน",
    vietnamese: "Sân bay",
    pronunciation: "Sạ-nảm-bin",
    category: "Địa điểm",
  },
  {
    id: 33,
    thai: "ไป",
    vietnamese: "Đi",
    pronunciation: "Pay",
    category: "Động từ",
  },
  {
    id: 34,
    thai: "เลี้ยวซ้าย",
    vietnamese: "Rẽ trái",
    pronunciation: "Liếu-sái",
    category: "Chỉ đường",
  },
  {
    id: 35,
    thai: "เลี้ยวขวา",
    vietnamese: "Rẽ phải",
    pronunciation: "Liếu-khỏa",
    category: "Chỉ đường",
  },
  {
    id: 36,
    thai: "ตรงไป",
    vietnamese: "Đi thẳng",
    pronunciation: "Trong-pay",
    category: "Chỉ đường",
  },
  {
    id: 37,
    thai: "หยุด",
    vietnamese: "Dừng lại",
    pronunciation: "Dụt",
    category: "Động từ",
  },
  {
    id: 38,
    thai: "เท่าไหร่",
    vietnamese: "Bao nhiêu tiền?",
    pronunciation: "Thau-rày",
    category: "Mua sắm",
  },
  {
    id: 39,
    thai: "แพง",
    vietnamese: "Đắt",
    pronunciation: "Pheng",
    category: "Mua sắm",
  },
  {
    id: 40,
    thai: "ลดได้ไหม",
    vietnamese: "Giảm giá được không?",
    pronunciation: "Lốt-đai-mảy",
    category: "Mua sắm",
  },

  // --- GIA ĐÌNH ---
  {
    id: 41,
    thai: "พ่อ",
    vietnamese: "Bố",
    pronunciation: "Phò",
    category: "Gia đình",
  },
  {
    id: 42,
    thai: "แม่",
    vietnamese: "Mẹ",
    pronunciation: "Me",
    category: "Gia đình",
  },
  {
    id: 43,
    thai: "พี่ชาย",
    vietnamese: "Anh trai",
    pronunciation: "Phi-chai",
    category: "Gia đình",
  },
  {
    id: 44,
    thai: "น้องสาว",
    vietnamese: "Em gái",
    pronunciation: "Noong-sảo",
    category: "Gia đình",
  },
  {
    id: 45,
    thai: "แฟน",
    vietnamese: "Người yêu / Bạn trai / Bạn gái",
    pronunciation: "Phen",
    category: "Gia đình",
  },

  // --- THỜI GIAN ---
  {
    id: 46,
    thai: "วันนี้",
    vietnamese: "Hôm nay",
    pronunciation: "Văn-ní",
    category: "Thời gian",
  },
  {
    id: 47,
    thai: "พรุ่งนี้",
    vietnamese: "Ngày mai",
    pronunciation: "Phrung-ní",
    category: "Thời gian",
  },
  {
    id: 48,
    thai: "เมื่อวาน",
    vietnamese: "Hôm qua",
    pronunciation: "Mưa-van",
    category: "Thời gian",
  },
  {
    id: 49,
    thai: "ตอนนี้",
    vietnamese: "Bây giờ",
    pronunciation: "Ton-ní",
    category: "Thời gian",
  },
  {
    id: 50,
    thai: "ชั่วโมง",
    vietnamese: "Giờ (đồng hồ)",
    pronunciation: "Chua-mông",
    category: "Thời gian",
  },
  // --- NGÀY TRONG TUẦN (DAYS OF WEEK) ---
  {
    id: 51,
    thai: "วันจันทร์",
    vietnamese: "Thứ Hai",
    pronunciation: "Văn-chăn",
    category: "Thời gian",
  },
  {
    id: 52,
    thai: "วันอังคาร",
    vietnamese: "Thứ Ba",
    pronunciation: "Văn-ăng-khan",
    category: "Thời gian",
  },
  {
    id: 53,
    thai: "วันพุธ",
    vietnamese: "Thứ Tư",
    pronunciation: "Văn-phút",
    category: "Thời gian",
  },
  {
    id: 54,
    thai: "วันพฤหัสบดี",
    vietnamese: "Thứ Năm",
    pronunciation: "Văn-phrư-hắt",
    category: "Thời gian",
  },
  {
    id: 55,
    thai: "วันศุกร์",
    vietnamese: "Thứ Sáu",
    pronunciation: "Văn-sục",
    category: "Thời gian",
  },
  {
    id: 56,
    thai: "วันเสาร์",
    vietnamese: "Thứ Bảy",
    pronunciation: "Văn-sảo",
    category: "Thời gian",
  },
  {
    id: 57,
    thai: "วันอาทิตย์",
    vietnamese: "Chủ Nhật",
    pronunciation: "Văn-a-thít",
    category: "Thời gian",
  },

  // --- MÀU SẮC (COLORS) ---
  {
    id: 58,
    thai: "สีแดง",
    vietnamese: "Màu đỏ",
    pronunciation: "Sỉ-đeng",
    category: "Màu sắc",
  },
  {
    id: 59,
    thai: "สีน้ำเงิน",
    vietnamese: "Màu xanh dương",
    pronunciation: "Sỉ-nam-ngơn",
    category: "Màu sắc",
  },
  {
    id: 60,
    thai: "สีเขียว",
    vietnamese: "Màu xanh lá",
    pronunciation: "Sỉ-khiếu",
    category: "Màu sắc",
  },
  {
    id: 61,
    thai: "สีขาว",
    vietnamese: "Màu trắng",
    pronunciation: "Sỉ-khảo",
    category: "Màu sắc",
  },
  {
    id: 62,
    thai: "สีดำ",
    vietnamese: "Màu đen",
    pronunciation: "Sỉ-đăm",
    category: "Màu sắc",
  },
  {
    id: 63,
    thai: "สีเหลือง",
    vietnamese: "Màu vàng",
    pronunciation: "Sỉ-lượng",
    category: "Màu sắc",
  },

  // --- PHƯƠNG TIỆN (TRANSPORTATION) ---
  {
    id: 64,
    thai: "รถยนต์",
    vietnamese: "Ô tô",
    pronunciation: "Rốt-yon",
    category: "Phương tiện",
  },
  {
    id: 65,
    thai: "รถแท็กซี่",
    vietnamese: "Taxi",
    pronunciation: "Rốt-théc-xi",
    category: "Phương tiện",
  },
  {
    id: 66,
    thai: "รถไฟ",
    vietnamese: "Tàu hỏa",
    pronunciation: "Rốt-phay",
    category: "Phương tiện",
  },
  {
    id: 67,
    thai: "รถไฟฟ้า (BTS)",
    vietnamese: "Tàu điện trên cao",
    pronunciation: "Rốt-phay-phá",
    category: "Phương tiện",
  },
  {
    id: 68,
    thai: "รถไฟใต้ดิน (MRT)",
    vietnamese: "Tàu điện ngầm",
    pronunciation: "Rốt-phay-tạy-đin",
    category: "Phương tiện",
  },
  {
    id: 69,
    thai: "เรือ",
    vietnamese: "Thuyền / Tàu thủy",
    pronunciation: "Rưa",
    category: "Phương tiện",
  },
  {
    id: 70,
    thai: "รถตุ๊กตุ๊ก",
    vietnamese: "Xe Tuk-tuk",
    pronunciation: "Rốt-túc-túc",
    category: "Phương tiện",
  },

  // --- TÍNH TỪ MÔ TẢ (ADJECTIVES) ---
  {
    id: 71,
    thai: "ร้อน",
    vietnamese: "Nóng",
    pronunciation: "Rón",
    category: "Tính từ",
  },
  {
    id: 72,
    thai: "หนาว",
    vietnamese: "Lạnh (thời tiết)",
    pronunciation: "Nảo",
    category: "Tính từ",
  },
  {
    id: 73,
    thai: "เย็น",
    vietnamese: "Lạnh / Mát (đồ vật/nước)",
    pronunciation: "Yên",
    category: "Tính từ",
  },
  {
    id: 74,
    thai: "ใหญ่",
    vietnamese: "To / Lớn",
    pronunciation: "Dày",
    category: "Tính từ",
  },
  {
    id: 75,
    thai: "เล็ก",
    vietnamese: "Nhỏ / Bé",
    pronunciation: "Lếc",
    category: "Tính từ",
  },
  {
    id: 76,
    thai: "สวย",
    vietnamese: "Đẹp",
    pronunciation: "Suổi",
    category: "Tính từ",
  },
  {
    id: 77,
    thai: "ดี",
    vietnamese: "Tốt",
    pronunciation: "Đi",
    category: "Tính từ",
  },
  {
    id: 78,
    thai: "เร็ว",
    vietnamese: "Nhanh",
    pronunciation: "Reo",
    category: "Tính từ",
  },
  {
    id: 79,
    thai: "ช้า",
    vietnamese: "Chậm",
    pronunciation: "Chá",
    category: "Tính từ",
  },

  // --- SỨC KHỎE & ĐỜI SỐNG (HEALTH) ---
  {
    id: 80,
    thai: "โรงพยาบาล",
    vietnamese: "Bệnh viện",
    pronunciation: "Rông-pha-ya-ban",
    category: "Sức khỏe",
  },
  {
    id: 81,
    thai: "หมอ",
    vietnamese: "Bác sĩ",
    pronunciation: "Mỏ",
    category: "Sức khỏe",
  },
  {
    id: 82,
    thai: "ยา",
    vietnamese: "Thuốc",
    pronunciation: "Ya",
    category: "Sức khỏe",
  },
  {
    id: 83,
    thai: "เป็นไข้",
    vietnamese: "Bị sốt",
    pronunciation: "Pen-khay",
    category: "Sức khỏe",
  },
  {
    id: 84,
    thai: "เจ็บ / ปวด",
    vietnamese: "Đau",
    pronunciation: "Chệp / Puột",
    category: "Sức khỏe",
  },
  {
    id: 85,
    thai: "ตำรวจ",
    vietnamese: "Cảnh sát",
    pronunciation: "Tam-ruột",
    category: "Khẩn cấp",
  },

  // --- ĐỘNG TỪ THÔNG DỤNG KHÁC (COMMON VERBS) ---
  {
    id: 86,
    thai: "ชอบ",
    vietnamese: "Thích",
    pronunciation: "Chợp",
    category: "Động từ",
  },
  {
    id: 87,
    thai: "รัก",
    vietnamese: "Yêu",
    pronunciation: "Rắc",
    category: "Động từ",
  },
  {
    id: 88,
    thai: "รู้",
    vietnamese: "Biết",
    pronunciation: "Rú",
    category: "Động từ",
  },
  {
    id: 89,
    thai: "เข้าใจ",
    vietnamese: "Hiểu",
    pronunciation: "Khau-chai",
    category: "Động từ",
  },
  {
    id: 90,
    thai: "ดู",
    vietnamese: "Xem / Nhìn",
    pronunciation: "Đu",
    category: "Động từ",
  },

  // --- TRÁI CÂY (FRUITS) - Rất phổ biến ở Thái ---
  {
    id: 91,
    thai: "ผลไม้",
    vietnamese: "Trái cây",
    pronunciation: "Phổn-la-mái",
    category: "Trái cây",
  },
  {
    id: 92,
    thai: "มะม่วง",
    vietnamese: "Xoài",
    pronunciation: "Ma-muộng",
    category: "Trái cây",
  },
  {
    id: 93,
    thai: "ทุเรียน",
    vietnamese: "Sầu riêng",
    pronunciation: "Thú-riên",
    category: "Trái cây",
  },
  {
    id: 94,
    thai: "มะพร้าว",
    vietnamese: "Dừa",
    pronunciation: "Ma-phrao",
    category: "Trái cây",
  },
  {
    id: 95,
    thai: "แตงโม",
    vietnamese: "Dưa hấu",
    pronunciation: "Teng-mô",
    category: "Trái cây",
  },
  {
    id: 96,
    thai: "ส้ม",
    vietnamese: "Cam",
    pronunciation: "Sôm",
    category: "Trái cây",
  },
  {
    id: 97,
    thai: "กล้วย",
    vietnamese: "Chuối",
    pronunciation: "Kluổi",
    category: "Trái cây",
  },
  {
    id: 98,
    thai: "มังคุด",
    vietnamese: "Măng cụt",
    pronunciation: "Măng-khút",
    category: "Trái cây",
  },

  // --- CẢM XÚC & TRẠNG THÁI (EMOTIONS) ---
  {
    id: 99,
    thai: "มีความสุข",
    vietnamese: "Hạnh phúc / Vui vẻ",
    pronunciation: "Mi-khoam-sục",
    category: "Cảm xúc",
  },
  {
    id: 100,
    thai: "เสียใจ",
    vietnamese: "Buồn / Tiếc nuối",
    pronunciation: "Sỉa-chai",
    category: "Cảm xúc",
  },
  {
    id: 101,
    thai: "เหนื่อย",
    vietnamese: "Mệt",
    pronunciation: "Nười",
    category: "Cảm xúc",
  },
  {
    id: 102,
    thai: "ง่วงนอน",
    vietnamese: "Buồn ngủ",
    pronunciation: "Nguộng-non",
    category: "Cảm xúc",
  },
  {
    id: 103,
    thai: "โกรธ",
    vietnamese: "Tức giận",
    pronunciation: "Krột",
    category: "Cảm xúc",
  },
  {
    id: 104,
    thai: "กลัว",
    vietnamese: "Sợ",
    pronunciation: "Klua",
    category: "Cảm xúc",
  },

  // --- ĐỒ DÙNG & TIỀN BẠC (DAILY OBJECTS) ---
  {
    id: 105,
    thai: "เงิน",
    vietnamese: "Tiền",
    pronunciation: "Ngơn",
    category: "Đồ dùng",
  },
  {
    id: 106,
    thai: "เงินทอน",
    vietnamese: "Tiền lẻ / Tiền thối",
    pronunciation: "Ngơn-thon",
    category: "Đồ dùng",
  },
  {
    id: 107,
    thai: "กระเป๋า",
    vietnamese: "Túi / Ba lô",
    pronunciation: "Ka-pảo",
    category: "Đồ dùng",
  },
  {
    id: 108,
    thai: "โทรศัพท์",
    vietnamese: "Điện thoại",
    pronunciation: "Thô-ra-sắp",
    category: "Đồ dùng",
  },
  {
    id: 109,
    thai: "กุญแจ",
    vietnamese: "Chìa khóa",
    pronunciation: "Cun-che",
    category: "Đồ dùng",
  },
  {
    id: 110,
    thai: "พาสปอร์ต",
    vietnamese: "Hộ chiếu",
    pronunciation: "Pát-sa-pọt",
    category: "Đồ dùng",
  },
  {
    id: 111,
    thai: "ตั๋ว",
    vietnamese: "Vé",
    pronunciation: "Tủa",
    category: "Đồ dùng",
  },

  // --- ĐỊA ĐIỂM BỔ SUNG ---
  {
    id: 112,
    thai: "ร้านขายยา",
    vietnamese: "Hiệu thuốc",
    pronunciation: "Rán-khải-ya",
    category: "Địa điểm",
  },
  {
    id: 113,
    thai: "สถานีตำรวจ",
    vietnamese: "Đồn cảnh sát",
    pronunciation: "Sa-thả-ni Tam-ruột",
    category: "Địa điểm",
  },
  {
    id: 114,
    thai: "ตลาด",
    vietnamese: "Chợ",
    pronunciation: "Ta-lạt",
    category: "Địa điểm",
  },
  {
    id: 115,
    thai: "ห้างสรรพสินค้า",
    vietnamese: "Trung tâm thương mại",
    pronunciation: "Hạng-sắp-pha-sỉn-khá",
    category: "Địa điểm",
  },

  // =================================================================
  // BỔ SUNG: ĐỘNG TỪ THÔNG DỤNG (COMMON VERBS)
  // =================================================================
  {
    id: 116,
    thai: "ทำ",
    vietnamese: "Làm",
    pronunciation: "Thăm",
    category: "Động từ",
  },
  {
    id: 117,
    thai: "ทำงาน",
    vietnamese: "Làm việc",
    pronunciation: "Thăm-ngan",
    category: "Động từ",
  },
  {
    id: 118,
    thai: "เรียน",
    vietnamese: "Học",
    pronunciation: "Riên",
    category: "Động từ",
  },
  {
    id: 119,
    thai: "สอน",
    vietnamese: "Dạy",
    pronunciation: "Sỏn",
    category: "Động từ",
  },
  {
    id: 120,
    thai: "นอน",
    vietnamese: "Ngủ",
    pronunciation: "Non",
    category: "Động từ",
  },
  {
    id: 121,
    thai: "ตื่น",
    vietnamese: "Thức dậy",
    pronunciation: "Từn",
    category: "Động từ",
  },
  {
    id: 122,
    thai: "นั่ง",
    vietnamese: "Ngồi",
    pronunciation: "Năng",
    category: "Động từ",
  },
  {
    id: 123,
    thai: "ยืน",
    vietnamese: "Đứng",
    pronunciation: "Dưn",
    category: "Động từ",
  },
  {
    id: 124,
    thai: "เดิน",
    vietnamese: "Đi bộ",
    pronunciation: "Đơn",
    category: "Động từ",
  },
  {
    id: 125,
    thai: "วิ่ง",
    vietnamese: "Chạy",
    pronunciation: "Ving",
    category: "Động từ",
  },
  {
    id: 126,
    thai: "อ่าน",
    vietnamese: "Đọc",
    pronunciation: "Àn",
    category: "Động từ",
  },
  {
    id: 127,
    thai: "เขียน",
    vietnamese: "Viết",
    pronunciation: "Khiển",
    category: "Động từ",
  },
  {
    id: 128,
    thai: "ฟัง",
    vietnamese: "Nghe",
    pronunciation: "Phăng",
    category: "Động từ",
  },
  {
    id: 129,
    thai: "พูด",
    vietnamese: "Nói",
    pronunciation: "Phút",
    category: "Động từ",
  },
  {
    id: 130,
    thai: "ดื่ม",
    vietnamese: "Uống",
    pronunciation: "Đừm",
    category: "Động từ",
  },
  {
    id: 131,
    thai: "ซื้อ",
    vietnamese: "Mua",
    pronunciation: "Sứ",
    category: "Động từ",
  },
  {
    id: 132,
    thai: "ขาย",
    vietnamese: "Bán",
    pronunciation: "Khải",
    category: "Động từ",
  },
  {
    id: 133,
    thai: "เปิด",
    vietnamese: "Mở / Bật",
    pronunciation: "Pợt",
    category: "Động từ",
  },
  {
    id: 134,
    thai: "ปิด",
    vietnamese: "Đóng / Tắt",
    pronunciation: "Pịt",
    category: "Động từ",
  },
  {
    id: 135,
    thai: "รอ",
    vietnamese: "Đợi / Chờ",
    pronunciation: "Ro",
    category: "Động từ",
  },
  {
    id: 136,
    thai: "ช่วย",
    vietnamese: "Giúp đỡ",
    pronunciation: "Chuổi",
    category: "Động từ",
  },
  {
    id: 137,
    thai: "พบ",
    vietnamese: "Gặp",
    pronunciation: "Phốp",
    category: "Động từ",
  },
  {
    id: 138,
    thai: "ถาม",
    vietnamese: "Hỏi",
    pronunciation: "Thảm",
    category: "Động từ",
  },
  {
    id: 139,
    thai: "ตอบ",
    vietnamese: "Trả lời",
    pronunciation: "Tộp",
    category: "Động từ",
  },
  {
    id: 140,
    thai: "คิด",
    vietnamese: "Nghĩ",
    pronunciation: "Khít",
    category: "Động từ",
  },
  {
    id: 141,
    thai: "ลืม",
    vietnamese: "Quên",
    pronunciation: "Lưm",
    category: "Động từ",
  },
  {
    id: 142,
    thai: "จำ",
    vietnamese: "Nhớ (ghi nhớ)",
    pronunciation: "Chăm",
    category: "Động từ",
  },
  {
    id: 143,
    thai: "ซักผ้า",
    vietnamese: "Giặt quần áo",
    pronunciation: "Sắc-phả",
    category: "Động từ",
  },
  {
    id: 144,
    thai: "ล้างจาน",
    vietnamese: "Rửa bát",
    pronunciation: "Láng-chan",
    category: "Động từ",
  },
  {
    id: 145,
    thai: "ทำความสะอาด",
    vietnamese: "Dọn dẹp / Làm sạch",
    pronunciation: "Thăm-khoam-sa-ạt",
    category: "Động từ",
  },
  {
    id: 146,
    thai: "อาบน้ำ",
    vietnamese: "Tắm",
    pronunciation: "Ạp-nám",
    category: "Động từ",
  },
  {
    id: 147,
    thai: "แปรงฟัน",
    vietnamese: "Đánh răng",
    pronunciation: "Preng-phăn",
    category: "Động từ",
  },
  {
    id: 148,
    thai: "แต่งตัว",
    vietnamese: "Mặc quần áo",
    pronunciation: "Tèng-tua",
    category: "Động từ",
  },
  {
    id: 149,
    thai: "ขับรถ",
    vietnamese: "Lái xe",
    pronunciation: "Khắp-rốt",
    category: "Động từ",
  },
  {
    id: 150,
    thai: "เที่ยว",
    vietnamese: "Đi chơi / Du lịch",
    pronunciation: "Thiếu",
    category: "Động từ",
  },
  {
    id: 151,
    thai: "กลับบ้าน",
    vietnamese: "Về nhà",
    pronunciation: "Klặp-bán",
    category: "Động từ",
  },
  {
    id: 152,
    thai: "โทรหา",
    vietnamese: "Gọi điện thoại",
    pronunciation: "Thô-hả",
    category: "Động từ",
  },
  {
    id: 153,
    thai: "เล่น",
    vietnamese: "Chơi",
    pronunciation: "Lên",
    category: "Động từ",
  },
  {
    id: 154,
    thai: "หัวเราะ",
    vietnamese: "Cười",
    pronunciation: "Hủa-rọ",
    category: "Động từ",
  },
  {
    id: 155,
    thai: "ร้องไห้",
    vietnamese: "Khóc",
    pronunciation: "Rọng-hhai",
    category: "Động từ",
  },

  // =================================================================
  // BỔ SUNG: TÍNH TỪ & CẶP TỪ TRÁI NGHĨA (ADJECTIVES)
  // =================================================================
  {
    id: 156,
    thai: "ใหม่",
    vietnamese: "Mới",
    pronunciation: "Mày",
    category: "Tính từ",
  },
  {
    id: 157,
    thai: "เก่า",
    vietnamese: "Cũ",
    pronunciation: "Kàu",
    category: "Tính từ",
  },
  {
    id: 158,
    thai: "ยาก",
    vietnamese: "Khó",
    pronunciation: "Dác",
    category: "Tính từ",
  },
  {
    id: 159,
    thai: "ง่าย",
    vietnamese: "Dễ",
    pronunciation: "Ngai",
    category: "Tính từ",
  },
  {
    id: 160,
    thai: "หนัก",
    vietnamese: "Nặng",
    pronunciation: "Nặc",
    category: "Tính từ",
  },
  {
    id: 161,
    thai: "เบา",
    vietnamese: "Nhẹ",
    pronunciation: "Bau",
    category: "Tính từ",
  },
  {
    id: 162,
    thai: "สูง",
    vietnamese: "Cao",
    pronunciation: "Sủng",
    category: "Tính từ",
  },
  {
    id: 163,
    thai: "เตี้ย",
    vietnamese: "Thấp / Lùn",
    pronunciation: "Tịa",
    category: "Tính từ",
  },
  {
    id: 164,
    thai: "ไกล",
    vietnamese: "Xa",
    pronunciation: "Klai",
    category: "Tính từ",
  },
  {
    id: 165,
    thai: "ใกล้",
    vietnamese: "Gần",
    pronunciation: "Klây",
    category: "Tính từ",
  },
  {
    id: 166,
    thai: "สะอาด",
    vietnamese: "Sạch sẽ",
    pronunciation: "Sa-ạt",
    category: "Tính từ",
  },
  {
    id: 167,
    thai: "สกปรก",
    vietnamese: "Bẩn",
    pronunciation: "Sốc-ka-prộc",
    category: "Tính từ",
  },
  {
    id: 168,
    thai: "รวย",
    vietnamese: "Giàu",
    pronunciation: "Ruôi",
    category: "Tính từ",
  },
  {
    id: 169,
    thai: "จน",
    vietnamese: "Nghèo",
    pronunciation: "Chôn",
    category: "Tính từ",
  },
  {
    id: 170,
    thai: "แข็งแรง",
    vietnamese: "Khỏe mạnh",
    pronunciation: "Kheng-reng",
    category: "Tính từ",
  },
  {
    id: 171,
    thai: "ป่วย",
    vietnamese: "Ốm / Bệnh",
    pronunciation: "Puồi",
    category: "Tính từ",
  },
  {
    id: 172,
    thai: "ฉลาด",
    vietnamese: "Thông minh",
    pronunciation: "Cha-lạt",
    category: "Tính từ",
  },
  {
    id: 173,
    thai: "โง่",
    vietnamese: "Ngu ngốc",
    pronunciation: "Ngô",
    category: "Tính từ",
  },
  {
    id: 174,
    thai: "เต็ม",
    vietnamese: "Đầy",
    pronunciation: "Tem",
    category: "Tính từ",
  },
  {
    id: 175,
    thai: "ว่าง",
    vietnamese: "Trống / Rảnh rỗi",
    pronunciation: "Vang",
    category: "Tính từ",
  },
  {
    id: 176,
    thai: "สำคัญ",
    vietnamese: "Quan trọng",
    pronunciation: "Sảm-khăn",
    category: "Tính từ",
  },
  {
    id: 177,
    thai: "อันตราย",
    vietnamese: "Nguy hiểm",
    pronunciation: "Ăn-ta-rai",
    category: "Tính từ",
  },
  {
    id: 178,
    thai: "ปลอดภัย",
    vietnamese: "An toàn",
    pronunciation: "Plọt-phay",
    category: "Tính từ",
  },
  {
    id: 179,
    thai: "เหมือน",
    vietnamese: "Giống",
    pronunciation: "Mượn",
    category: "Tính từ",
  },
  {
    id: 180,
    thai: "ต่าง",
    vietnamese: "Khác",
    pronunciation: "Tàng",
    category: "Tính từ",
  },

  // =================================================================
  // BỔ SUNG: CƠ THỂ CON NGƯỜI (BODY PARTS)
  // =================================================================
  {
    id: 181,
    thai: "หัว / ศีรษะ",
    vietnamese: "Đầu",
    pronunciation: "Hủa / Sỉ-sạ",
    category: "Cơ thể",
  },
  {
    id: 182,
    thai: "ผม",
    vietnamese: "Tóc",
    pronunciation: "Phổm",
    category: "Cơ thể",
  },
  {
    id: 183,
    thai: "หน้า",
    vietnamese: "Mặt",
    pronunciation: "Nạ",
    category: "Cơ thể",
  },
  {
    id: 184,
    thai: "ตา",
    vietnamese: "Mắt",
    pronunciation: "Ta",
    category: "Cơ thể",
  },
  {
    id: 185,
    thai: "หู",
    vietnamese: "Tai",
    pronunciation: "Hủ",
    category: "Cơ thể",
  },
  {
    id: 186,
    thai: "จมูก",
    vietnamese: "Mũi",
    pronunciation: "Cha-mục",
    category: "Cơ thể",
  },
  {
    id: 187,
    thai: "ปาก",
    vietnamese: "Miệng",
    pronunciation: "Pạc",
    category: "Cơ thể",
  },
  {
    id: 188,
    thai: "ฟัน",
    vietnamese: "Răng",
    pronunciation: "Phăn",
    category: "Cơ thể",
  },
  {
    id: 189,
    thai: "คอ",
    vietnamese: "Cổ",
    pronunciation: "Kho",
    category: "Cơ thể",
  },
  {
    id: 190,
    thai: "ไหล่",
    vietnamese: "Vai",
    pronunciation: "Lày",
    category: "Cơ thể",
  },
  {
    id: 191,
    thai: "แขน",
    vietnamese: "Cánh tay",
    pronunciation: "Khẻn",
    category: "Cơ thể",
  },
  {
    id: 192,
    thai: "มือ",
    vietnamese: "Bàn tay",
    pronunciation: "Mư",
    category: "Cơ thể",
  },
  {
    id: 193,
    thai: "นิ้ว",
    vietnamese: "Ngón tay",
    pronunciation: "Níu",
    category: "Cơ thể",
  },
  {
    id: 194,
    thai: "หน้าอก",
    vietnamese: "Ngực",
    pronunciation: "Nạ-ộc",
    category: "Cơ thể",
  },
  {
    id: 195,
    thai: "ท้อง",
    vietnamese: "Bụng",
    pronunciation: "Thóng",
    category: "Cơ thể",
  },
  {
    id: 196,
    thai: "หลัง",
    vietnamese: "Lưng",
    pronunciation: "Lẳng",
    category: "Cơ thể",
  },
  {
    id: 197,
    thai: "ขา",
    vietnamese: "Chân",
    pronunciation: "Khả",
    category: "Cơ thể",
  },
  {
    id: 198,
    thai: "เท้า",
    vietnamese: "Bàn chân",
    pronunciation: "Tháo",
    category: "Cơ thể",
  },
  {
    id: 199,
    thai: "หัวใจ",
    vietnamese: "Trái tim",
    pronunciation: "Hủa-chai",
    category: "Cơ thể",
  },
  {
    id: 200,
    thai: "เลือด",
    vietnamese: "Máu",
    pronunciation: "Lượt",
    category: "Cơ thể",
  },

  // =================================================================
  // BỔ SUNG: QUẦN ÁO & PHỤ KIỆN (CLOTHING)
  // =================================================================
  {
    id: 201,
    thai: "เสื้อ",
    vietnamese: "Áo",
    pronunciation: "Sứa",
    category: "Quần áo",
  },
  {
    id: 202,
    thai: "กางเกง",
    vietnamese: "Quần",
    pronunciation: "Kang-keng",
    category: "Quần áo",
  },
  {
    id: 203,
    thai: "เสื้อยืด",
    vietnamese: "Áo phông (T-shirt)",
    pronunciation: "Sứa-dứt",
    category: "Quần áo",
  },
  {
    id: 204,
    thai: "กระโปรง",
    vietnamese: "Váy (chân váy)",
    pronunciation: "Kra-prông",
    category: "Quần áo",
  },
  {
    id: 205,
    thai: "ชุดเดรส",
    vietnamese: "Đầm liền",
    pronunciation: "Chút-đrết",
    category: "Quần áo",
  },
  {
    id: 206,
    thai: "รองเท้า",
    vietnamese: "Giày",
    pronunciation: "Roong-tháo",
    category: "Quần áo",
  },
  {
    id: 207,
    thai: "ถุงเท้า",
    vietnamese: "Tất (vớ)",
    pronunciation: "Thủng-tháo",
    category: "Quần áo",
  },
  {
    id: 208,
    thai: "หมวก",
    vietnamese: "Mũ / Nón",
    pronunciation: "Muộc",
    category: "Quần áo",
  },
  {
    id: 209,
    thai: "แว่นตา",
    vietnamese: "Kính mắt",
    pronunciation: "Wèn-ta",
    category: "Quần áo",
  },
  {
    id: 210,
    thai: "นาฬิกา",
    vietnamese: "Đồng hồ",
    pronunciation: "Na-li-ka",
    category: "Quần áo",
  },
  {
    id: 211,
    thai: "แหวน",
    vietnamese: "Nhẫn",
    pronunciation: "Wẻn",
    category: "Quần áo",
  },
  {
    id: 212,
    thai: "สร้อยคอ",
    vietnamese: "Dây chuyền",
    pronunciation: "Sói-kho",
    category: "Quần áo",
  },
  {
    id: 213,
    thai: "เข็มขัด",
    vietnamese: "Thắt lưng",
    pronunciation: "Khểm-khặt",
    category: "Quần áo",
  },
  {
    id: 214,
    thai: "เสื้อกันหนาว",
    vietnamese: "Áo khoác / Áo ấm",
    pronunciation: "Sứa-kan-nảo",
    category: "Quần áo",
  },
  {
    id: 215,
    thai: "ชุดว่ายน้ำ",
    vietnamese: "Đồ bơi",
    pronunciation: "Chút-wai-nám",
    category: "Quần áo",
  },

  // =================================================================
  // BỔ SUNG: NHÀ CỬA & ĐỒ DÙNG TRONG NHÀ (HOME)
  // =================================================================
  {
    id: 216,
    thai: "บ้าน",
    vietnamese: "Nhà",
    pronunciation: "Bán",
    category: "Nhà cửa",
  },
  {
    id: 217,
    thai: "ห้อง",
    vietnamese: "Phòng",
    pronunciation: "Hoọng",
    category: "Nhà cửa",
  },
  {
    id: 218,
    thai: "ห้องนอน",
    vietnamese: "Phòng ngủ",
    pronunciation: "Hoọng-non",
    category: "Nhà cửa",
  },
  {
    id: 219,
    thai: "ห้องครัว",
    vietnamese: "Phòng bếp",
    pronunciation: "Hoọng-khrua",
    category: "Nhà cửa",
  },
  {
    id: 220,
    thai: "ห้องนั่งเล่น",
    vietnamese: "Phòng khách",
    pronunciation: "Hoọng-năng-lên",
    category: "Nhà cửa",
  },
  {
    id: 221,
    thai: "ประตู",
    vietnamese: "Cửa",
    pronunciation: "Pra-tu",
    category: "Nhà cửa",
  },
  {
    id: 222,
    thai: "หน้าต่าง",
    vietnamese: "Cửa sổ",
    pronunciation: "Nạ-tàng",
    category: "Nhà cửa",
  },
  {
    id: 223,
    thai: "เตียง",
    vietnamese: "Giường",
    pronunciation: "Tiêng",
    category: "Nhà cửa",
  },
  {
    id: 224,
    thai: "เก้าอี้",
    vietnamese: "Ghế",
    pronunciation: "Kao-ý",
    category: "Nhà cửa",
  },
  {
    id: 225,
    thai: "โต๊ะ",
    vietnamese: "Bàn",
    pronunciation: "Tố",
    category: "Nhà cửa",
  },
  {
    id: 226,
    thai: "ตู้เย็น",
    vietnamese: "Tủ lạnh",
    pronunciation: "Tu-yên",
    category: "Nhà cửa",
  },
  {
    id: 227,
    thai: "ทีวี",
    vietnamese: "Ti vi",
    pronunciation: "Thi-vi",
    category: "Nhà cửa",
  },
  {
    id: 228,
    thai: "พัดลม",
    vietnamese: "Quạt",
    pronunciation: "Phắt-lôm",
    category: "Nhà cửa",
  },
  {
    id: 229,
    thai: "แอร์",
    vietnamese: "Điều hòa (Air)",
    pronunciation: "E",
    category: "Nhà cửa",
  },
  {
    id: 230,
    thai: "จาน",
    vietnamese: "Đĩa",
    pronunciation: "Chan",
    category: "Nhà cửa",
  },
  {
    id: 231,
    thai: "ชาม",
    vietnamese: "Bát (tô)",
    pronunciation: "Cham",
    category: "Nhà cửa",
  },
  {
    id: 232,
    thai: "ช้อน",
    vietnamese: "Thìa",
    pronunciation: "Chón",
    category: "Nhà cửa",
  },
  {
    id: 233,
    thai: "ส้อม",
    vietnamese: "Dĩa (nĩa)",
    pronunciation: "Sóm",
    category: "Nhà cửa",
  },
  {
    id: 234,
    thai: "แก้ว",
    vietnamese: "Cốc / Ly",
    pronunciation: "Kéo",
    category: "Nhà cửa",
  },
  {
    id: 235,
    thai: "สบู่",
    vietnamese: "Xà phòng",
    pronunciation: "Sa-bù",
    category: "Nhà cửa",
  },
  {
    id: 236,
    thai: "ยาสระผม",
    vietnamese: "Dầu gội đầu",
    pronunciation: "Ya-sa-phổm",
    category: "Nhà cửa",
  },
  {
    id: 237,
    thai: "ยาสีฟัน",
    vietnamese: "Kem đánh răng",
    pronunciation: "Ya-sỉ-phăn",
    category: "Nhà cửa",
  },
  {
    id: 238,
    thai: "ผ้าเช็ดตัว",
    vietnamese: "Khăn tắm",
    pronunciation: "Phả-chết-tua",
    category: "Nhà cửa",
  },
  {
    id: 239,
    thai: "กระจก",
    vietnamese: "Gương",
    pronunciation: "Kra-chộc",
    category: "Nhà cửa",
  },
  {
    id: 240,
    thai: "หมอน",
    vietnamese: "Gối",
    pronunciation: "Mỏn",
    category: "Nhà cửa",
  },

  // =================================================================
  // BỔ SUNG: THỰC PHẨM & TRÁI CÂY (FOOD & FRUITS EXTENDED)
  // =================================================================
  {
    id: 241,
    thai: "เนื้อวัว",
    vietnamese: "Thịt bò",
    pronunciation: "Nứa-vua",
    category: "Thực phẩm",
  },
  {
    id: 242,
    thai: "เป็ด",
    vietnamese: "Vịt",
    pronunciation: "Pệt",
    category: "Thực phẩm",
  },
  {
    id: 243,
    thai: "ปลา",
    vietnamese: "Cá",
    pronunciation: "Pla",
    category: "Thực phẩm",
  },
  {
    id: 244,
    thai: "กุ้ง",
    vietnamese: "Tôm",
    pronunciation: "Kung",
    category: "Thực phẩm",
  },
  {
    id: 245,
    thai: "ปู",
    vietnamese: "Cua",
    pronunciation: "Pu",
    category: "Thực phẩm",
  },
  {
    id: 246,
    thai: "ปลาหมึก",
    vietnamese: "Mực",
    pronunciation: "Pla-mực",
    category: "Thực phẩm",
  },
  {
    id: 247,
    thai: "ไข่",
    vietnamese: "Trứng",
    pronunciation: "Khày",
    category: "Thực phẩm",
  },
  {
    id: 248,
    thai: "ผัก",
    vietnamese: "Rau",
    pronunciation: "Phặc",
    category: "Thực phẩm",
  },
  {
    id: 249,
    thai: "ข้าว",
    vietnamese: "Cơm / Gạo",
    pronunciation: "Khao",
    category: "Thực phẩm",
  },
  {
    id: 250,
    thai: "ก๋วยเตี๋ยว",
    vietnamese: "Hủ tiếu / Phở",
    pronunciation: "Kuổi-tiểu",
    category: "Thực phẩm",
  },
  {
    id: 251,
    thai: "ขนมปัง",
    vietnamese: "Bánh mì",
    pronunciation: "Khạ-nổm-pang",
    category: "Thực phẩm",
  },
  {
    id: 252,
    thai: "น้ำตาล",
    vietnamese: "Đường",
    pronunciation: "Nam-tan",
    category: "Thực phẩm",
  },
  {
    id: 253,
    thai: "เกลือ",
    vietnamese: "Muối",
    pronunciation: "Klưa",
    category: "Thực phẩm",
  },
  {
    id: 254,
    thai: "น้ำปลา",
    vietnamese: "Nước mắm",
    pronunciation: "Nam-pla",
    category: "Thực phẩm",
  },
  {
    id: 255,
    thai: "พริก",
    vietnamese: "Ớt",
    pronunciation: "Phrích",
    category: "Thực phẩm",
  },
  {
    id: 256,
    thai: "มะนาว",
    vietnamese: "Chanh",
    pronunciation: "Ma-nao",
    category: "Thực phẩm",
  },
  {
    id: 257,
    thai: "กระเทียม",
    vietnamese: "Tỏi",
    pronunciation: "Kra-thiêm",
    category: "Thực phẩm",
  },
  {
    id: 258,
    thai: "แตงกวา",
    vietnamese: "Dưa chuột",
    pronunciation: "Teng-kua",
    category: "Thực phẩm",
  },
  {
    id: 259,
    thai: "สับปะรด",
    vietnamese: "Dứa (Thơm)",
    pronunciation: "Sắp-pa-rốt",
    category: "Trái cây",
  },
  {
    id: 260,
    thai: "มะละกอ",
    vietnamese: "Đu đủ",
    pronunciation: "Ma-la-ko",
    category: "Trái cây",
  },
  {
    id: 261,
    thai: "เงาะ",
    vietnamese: "Chôm chôm",
    pronunciation: "Ngọ",
    category: "Trái cây",
  },
  {
    id: 262,
    thai: "ลำไย",
    vietnamese: "Nhãn",
    pronunciation: "Lăm-yai",
    category: "Trái cây",
  },
  {
    id: 263,
    thai: "องุ่น",
    vietnamese: "Nho",
    pronunciation: "A-ngùn",
    category: "Trái cây",
  },
  {
    id: 264,
    thai: "แอปเปิ้ล",
    vietnamese: "Táo",
    pronunciation: "Ép-pơn",
    category: "Trái cây",
  },
  {
    id: 265,
    thai: "ชมพู่",
    vietnamese: "Mận (roi)",
    pronunciation: "Chôm-phu",
    category: "Trái cây",
  },

  // =================================================================
  // BỔ SUNG: ĐỘNG VẬT (ANIMALS)
  // =================================================================
  {
    id: 266,
    thai: "สัตว์",
    vietnamese: "Động vật",
    pronunciation: "Sắt",
    category: "Động vật",
  },
  {
    id: 267,
    thai: "หมา",
    vietnamese: "Chó",
    pronunciation: "Mả",
    category: "Động vật",
  },
  {
    id: 268,
    thai: "แมว",
    vietnamese: "Mèo",
    pronunciation: "Meo",
    category: "Động vật",
  },
  {
    id: 269,
    thai: "ช้าง",
    vietnamese: "Voi",
    pronunciation: "Cháng",
    category: "Động vật",
  },
  {
    id: 270,
    thai: "ม้า",
    vietnamese: "Ngựa",
    pronunciation: "Má",
    category: "Động vật",
  },
  {
    id: 271,
    thai: "วัว",
    vietnamese: "Bò",
    pronunciation: "Vua",
    category: "Động vật",
  },
  {
    id: 272,
    thai: "ควาย",
    vietnamese: "Trâu",
    pronunciation: "Khoai",
    category: "Động vật",
  },
  {
    id: 273,
    thai: "นก",
    vietnamese: "Chim",
    pronunciation: "Nốc",
    category: "Động vật",
  },
  {
    id: 274,
    thai: "ลิง",
    vietnamese: "Khỉ",
    pronunciation: "Ling",
    category: "Động vật",
  },
  {
    id: 275,
    thai: "เสือ",
    vietnamese: "Hổ",
    pronunciation: "Sứa",
    category: "Động vật",
  },
  {
    id: 276,
    thai: "งู",
    vietnamese: "Rắn",
    pronunciation: "Ngu",
    category: "Động vật",
  },
  {
    id: 277,
    thai: "ยุง",
    vietnamese: "Muỗi",
    pronunciation: "Yung",
    category: "Động vật",
  },
  {
    id: 278,
    thai: "มด",
    vietnamese: "Kiến",
    pronunciation: "Mốt",
    category: "Động vật",
  },
  {
    id: 279,
    thai: "กระต่าย",
    vietnamese: "Thỏ",
    pronunciation: "Kra-tài",
    category: "Động vật",
  },
  {
    id: 280,
    thai: "หนู",
    vietnamese: "Chuột",
    pronunciation: "Nủ",
    category: "Động vật",
  },

  // =================================================================
  // BỔ SUNG: NGHỀ NGHIỆP (OCCUPATIONS)
  // =================================================================
  {
    id: 281,
    thai: "ครู",
    vietnamese: "Giáo viên",
    pronunciation: "Khru",
    category: "Nghề nghiệp",
  },
  {
    id: 282,
    thai: "นักเรียน",
    vietnamese: "Học sinh",
    pronunciation: "Nắc-riên",
    category: "Nghề nghiệp",
  },
  {
    id: 283,
    thai: "หมอ",
    vietnamese: "Bác sĩ",
    pronunciation: "Mỏ",
    category: "Nghề nghiệp",
  },
  {
    id: 284,
    thai: "พยาบาล",
    vietnamese: "Y tá",
    pronunciation: "Pha-ya-ban",
    category: "Nghề nghiệp",
  },
  {
    id: 285,
    thai: "วิศวกร",
    vietnamese: "Kỹ sư",
    pronunciation: "Vít-sa-wa-kon",
    category: "Nghề nghiệp",
  },
  {
    id: 286,
    thai: "ตำรวจ",
    vietnamese: "Cảnh sát",
    pronunciation: "Tam-ruột",
    category: "Nghề nghiệp",
  },
  {
    id: 287,
    thai: "ทหาร",
    vietnamese: "Bộ đội",
    pronunciation: "Tha-hản",
    category: "Nghề nghiệp",
  },
  {
    id: 288,
    thai: "พ่อครัว",
    vietnamese: "Đầu bếp",
    pronunciation: "Phò-khrua",
    category: "Nghề nghiệp",
  },
  {
    id: 289,
    thai: "นักร้อง",
    vietnamese: "Ca sĩ",
    pronunciation: "Nắc-rọng",
    category: "Nghề nghiệp",
  },
  {
    id: 290,
    thai: "พนักงาน",
    vietnamese: "Nhân viên",
    pronunciation: "Pha-nắc-ngan",
    category: "Nghề nghiệp",
  },
  {
    id: 291,
    thai: "คนขับรถ",
    vietnamese: "Tài xế",
    pronunciation: "Khon-khắp-rốt",
    category: "Nghề nghiệp",
  },
  {
    id: 292,
    thai: "แม่ค้า",
    vietnamese: "Người bán hàng (nữ)",
    pronunciation: "Me-khá",
    category: "Nghề nghiệp",
  },
  {
    id: 293,
    thai: "พ่อค้า",
    vietnamese: "Người bán hàng (nam)",
    pronunciation: "Phò-khá",
    category: "Nghề nghiệp",
  },

  // =================================================================
  // BỔ SUNG: THIÊN NHIÊN & ĐỊA LÝ (NATURE)
  // =================================================================
  {
    id: 294,
    thai: "พระอาทิตย์",
    vietnamese: "Mặt trời",
    pronunciation: "Phra-a-thít",
    category: "Thiên nhiên",
  },
  {
    id: 295,
    thai: "พระจันทร์",
    vietnamese: "Mặt trăng",
    pronunciation: "Phra-chăn",
    category: "Thiên nhiên",
  },
  {
    id: 296,
    thai: "ดาว",
    vietnamese: "Ngôi sao",
    pronunciation: "Đao",
    category: "Thiên nhiên",
  },
  {
    id: 297,
    thai: "ท้องฟ้า",
    vietnamese: "Bầu trời",
    pronunciation: "Thóng-phá",
    category: "Thiên nhiên",
  },
  {
    id: 298,
    thai: "เมฆ",
    vietnamese: "Mây",
    pronunciation: "Mếk",
    category: "Thiên nhiên",
  },
  {
    id: 299,
    thai: "ฝน",
    vietnamese: "Mưa",
    pronunciation: "Phổn",
    category: "Thiên nhiên",
  },
  {
    id: 300,
    thai: "ลม",
    vietnamese: "Gió",
    pronunciation: "Lôm",
    category: "Thiên nhiên",
  },
  {
    id: 301,
    thai: "น้ำ",
    vietnamese: "Nước",
    pronunciation: "Nam",
    category: "Thiên nhiên",
  },
  {
    id: 302,
    thai: "ไฟ",
    vietnamese: "Lửa",
    pronunciation: "Phay",
    category: "Thiên nhiên",
  },
  {
    id: 303,
    thai: "ทะเล",
    vietnamese: "Biển",
    pronunciation: "Tha-lê",
    category: "Thiên nhiên",
  },
  {
    id: 304,
    thai: "ภูเขา",
    vietnamese: "Núi",
    pronunciation: "Phu-khảo",
    category: "Thiên nhiên",
  },
  {
    id: 305,
    thai: "แม่น้ำ",
    vietnamese: "Sông",
    pronunciation: "Me-nám",
    category: "Thiên nhiên",
  },
  {
    id: 306,
    thai: "ป่า",
    vietnamese: "Rừng",
    pronunciation: "Pà",
    category: "Thiên nhiên",
  },
  {
    id: 307,
    thai: "ต้นไม้",
    vietnamese: "Cây",
    pronunciation: "Tôn-mái",
    category: "Thiên nhiên",
  },
  {
    id: 308,
    thai: "ดอกไม้",
    vietnamese: "Hoa",
    pronunciation: "Đọc-mái",
    category: "Thiên nhiên",
  },

  // =================================================================
  // BỔ SUNG: THỜI GIAN & LỊCH (MONTHS & TIME)
  // =================================================================
  {
    id: 309,
    thai: "ปี",
    vietnamese: "Năm",
    pronunciation: "Pi",
    category: "Thời gian",
  },
  {
    id: 310,
    thai: "เดือน",
    vietnamese: "Tháng",
    pronunciation: "Đươn",
    category: "Thời gian",
  },
  {
    id: 311,
    thai: "สัปดาห์",
    vietnamese: "Tuần",
    pronunciation: "Sắp-đa",
    category: "Thời gian",
  },
  {
    id: 312,
    thai: "วัน",
    vietnamese: "Ngày",
    pronunciation: "Văn",
    category: "Thời gian",
  },
  {
    id: 313,
    thai: "นาที",
    vietnamese: "Phút",
    pronunciation: "Na-thi",
    category: "Thời gian",
  },
  {
    id: 314,
    thai: "วินาที",
    vietnamese: "Giây",
    pronunciation: "Vi-na-thi",
    category: "Thời gian",
  },
  {
    id: 315,
    thai: "เช้า",
    vietnamese: "Buổi sáng",
    pronunciation: "Cháo",
    category: "Thời gian",
  },
  {
    id: 316,
    thai: "เที่ยง",
    vietnamese: "Buổi trưa",
    pronunciation: "Thiêng",
    category: "Thời gian",
  },
  {
    id: 317,
    thai: "บ่าย",
    vietnamese: "Buổi chiều",
    pronunciation: "Bài",
    category: "Thời gian",
  },
  {
    id: 318,
    thai: "เย็น",
    vietnamese: "Buổi tối (chiều muộn)",
    pronunciation: "Yên",
    category: "Thời gian",
  },
  {
    id: 319,
    thai: "ดึก",
    vietnamese: "Đêm khuya",
    pronunciation: "Đực",
    category: "Thời gian",
  },
  {
    id: 320,
    thai: "มกราคม",
    vietnamese: "Tháng 1",
    pronunciation: "Môk-ka-ra-khom",
    category: "Thời gian",
  },
  {
    id: 321,
    thai: "กุมภาพันธ์",
    vietnamese: "Tháng 2",
    pronunciation: "Kum-pha-phăn",
    category: "Thời gian",
  },
  {
    id: 322,
    thai: "มีนาคม",
    vietnamese: "Tháng 3",
    pronunciation: "Mi-na-khom",
    category: "Thời gian",
  },
  {
    id: 323,
    thai: "เมษายน",
    vietnamese: "Tháng 4",
    pronunciation: "Mê-sả-yon",
    category: "Thời gian",
  },
  {
    id: 324,
    thai: "พฤษภาคม",
    vietnamese: "Tháng 5",
    pronunciation: "Phrức-sa-pha-khom",
    category: "Thời gian",
  },
  {
    id: 325,
    thai: "มิถุนายน",
    vietnamese: "Tháng 6",
    pronunciation: "Mi-thu-nả-yon",
    category: "Thời gian",
  },
  {
    id: 326,
    thai: "กรกฎาคม",
    vietnamese: "Tháng 7",
    pronunciation: "Ka-rắc-ka-đa-khom",
    category: "Thời gian",
  },
  {
    id: 327,
    thai: "สิงหาคม",
    vietnamese: "Tháng 8",
    pronunciation: "Sỉng-hả-khom",
    category: "Thời gian",
  },
  {
    id: 328,
    thai: "กันยายน",
    vietnamese: "Tháng 9",
    pronunciation: "Kăn-ya-yon",
    category: "Thời gian",
  },
  {
    id: 329,
    thai: "ตุลาคม",
    vietnamese: "Tháng 10",
    pronunciation: "Tu-la-khom",
    category: "Thời gian",
  },
  {
    id: 330,
    thai: "พฤศจิกายน",
    vietnamese: "Tháng 11",
    pronunciation: "Phrức-sa-chi-ka-yon",
    category: "Thời gian",
  },
  {
    id: 331,
    thai: "ธันวาคม",
    vietnamese: "Tháng 12",
    pronunciation: "Thăn-wa-khom",
    category: "Thời gian",
  },

  // =================================================================
  // BỔ SUNG: MÀU SẮC (EXTENDED COLORS)
  // =================================================================
  {
    id: 332,
    thai: "สีชมพู",
    vietnamese: "Màu hồng",
    pronunciation: "Sỉ-chôm-phu",
    category: "Màu sắc",
  },
  {
    id: 333,
    thai: "สีส้ม",
    vietnamese: "Màu cam",
    pronunciation: "Sỉ-sôm",
    category: "Màu sắc",
  },
  {
    id: 334,
    thai: "สีม่วง",
    vietnamese: "Màu tím",
    pronunciation: "Sỉ-muộng",
    category: "Màu sắc",
  },
  {
    id: 335,
    thai: "สีน้ำตาล",
    vietnamese: "Màu nâu",
    pronunciation: "Sỉ-nam-tan",
    category: "Màu sắc",
  },
  {
    id: 336,
    thai: "สีเทา",
    vietnamese: "Màu xám",
    pronunciation: "Sỉ-thau",
    category: "Màu sắc",
  },
  {
    id: 337,
    thai: "สีทอง",
    vietnamese: "Màu vàng kim",
    pronunciation: "Sỉ-thoong",
    category: "Màu sắc",
  },
  {
    id: 338,
    thai: "สีเงิน",
    vietnamese: "Màu bạc",
    pronunciation: "Sỉ-ngơn",
    category: "Màu sắc",
  },

  // =================================================================
  // BỔ SUNG: ĐỊA ĐIỂM & HƯỚNG (PLACES & DIRECTIONS)
  // =================================================================
  {
    id: 339,
    thai: "โรงเรียน",
    vietnamese: "Trường học",
    pronunciation: "Rông-riên",
    category: "Địa điểm",
  },
  {
    id: 340,
    thai: "มหาวิทยาลัย",
    vietnamese: "Đại học",
    pronunciation: "Ma-hả-wit-tha-ya-lai",
    category: "Địa điểm",
  },
  {
    id: 341,
    thai: "ธนาคาร",
    vietnamese: "Ngân hàng",
    pronunciation: "Tha-na-khan",
    category: "Địa điểm",
  },
  {
    id: 342,
    thai: "ไปรษณีย์",
    vietnamese: "Bưu điện",
    pronunciation: "Prai-sa-ni",
    category: "Địa điểm",
  },
  {
    id: 343,
    thai: "วัด",
    vietnamese: "Chùa",
    pronunciation: "Vắt",
    category: "Địa điểm",
  },
  {
    id: 344,
    thai: "สวนสัตว์",
    vietnamese: "Sở thú",
    pronunciation: "Suổn-sắt",
    category: "Địa điểm",
  },
  {
    id: 345,
    thai: "สวนสาธารณะ",
    vietnamese: "Công viên",
    pronunciation: "Suổn-sa-tha-ra-nạ",
    category: "Địa điểm",
  },
  {
    id: 346,
    thai: "ร้านอาหาร",
    vietnamese: "Nhà hàng",
    pronunciation: "Rán-a-hản",
    category: "Địa điểm",
  },
  {
    id: 347,
    thai: "ร้านกาแฟ",
    vietnamese: "Quán cà phê",
    pronunciation: "Rán-ka-phe",
    category: "Địa điểm",
  },
  {
    id: 348,
    thai: "เหนือ",
    vietnamese: "Phía Bắc",
    pronunciation: "Nửa",
    category: "Phương hướng",
  },
  {
    id: 349,
    thai: "ใต้",
    vietnamese: "Phía Nam",
    pronunciation: "Tây",
    category: "Phương hướng",
  },
  {
    id: 350,
    thai: "ออก",
    vietnamese: "Phía Đông / Ra",
    pronunciation: "Ọoc",
    category: "Phương hướng",
  },
  {
    id: 351,
    thai: "ตก",
    vietnamese: "Phía Tây / Rơi",
    pronunciation: "Tộc",
    category: "Phương hướng",
  },
  {
    id: 352,
    thai: "บน",
    vietnamese: "Trên",
    pronunciation: "Bôn",
    category: "Giới từ",
  },
  {
    id: 353,
    thai: "ล่าง",
    vietnamese: "Dưới",
    pronunciation: "Làng",
    category: "Giới từ",
  },
  {
    id: 354,
    thai: "ใน",
    vietnamese: "Trong",
    pronunciation: "Nay",
    category: "Giới từ",
  },
  {
    id: 355,
    thai: "นอก",
    vietnamese: "Ngoài",
    pronunciation: "Nọc",
    category: "Giới từ",
  },
  {
    id: 356,
    thai: "ที่นี่",
    vietnamese: "Ở đây",
    pronunciation: "Thi-ni",
    category: "Đại từ",
  },
  {
    id: 357,
    thai: "ที่นั่น",
    vietnamese: "Ở đó",
    pronunciation: "Thi-nân",
    category: "Đại từ",
  },
  {
    id: 358,
    thai: "ที่โน่น",
    vietnamese: "Ở kia (xa)",
    pronunciation: "Thi-nôn",
    category: "Đại từ",
  },

  // =================================================================
  // BỔ SUNG: TỪ NỐI & KHÁC (MISCELLANEOUS)
  // =================================================================
  {
    id: 359,
    thai: "และ",
    vietnamese: "Và",
    pronunciation: "Lẹ",
    category: "Từ nối",
  },
  {
    id: 360,
    thai: "แต่",
    vietnamese: "Nhưng",
    pronunciation: "Tè",
    category: "Từ nối",
  },
  {
    id: 361,
    thai: "หรือ",
    vietnamese: "Hoặc",
    pronunciation: "Rử",
    category: "Từ nối",
  },
  {
    id: 362,
    thai: "เพราะ",
    vietnamese: "Bởi vì",
    pronunciation: "Ph-rọ",
    category: "Từ nối",
  },
  {
    id: 363,
    thai: "ถ้า",
    vietnamese: "Nếu",
    pronunciation: "Thạ",
    category: "Từ nối",
  },
  {
    id: 364,
    thai: "ใคร",
    vietnamese: "Ai",
    pronunciation: "Khray",
    category: "Từ để hỏi",
  },
  {
    id: 365,
    thai: "อะไร",
    vietnamese: "Cái gì",
    pronunciation: "A-ray",
    category: "Từ để hỏi",
  },
  {
    id: 366,
    thai: "ที่ไหน",
    vietnamese: "Ở đâu",
    pronunciation: "Thi-nảy",
    category: "Từ để hỏi",
  },
  {
    id: 367,
    thai: "เมื่อไหร่",
    vietnamese: "Khi nào",
    pronunciation: "Mưa-rày",
    category: "Từ để hỏi",
  },
  {
    id: 368,
    thai: "ทำไม",
    vietnamese: "Tại sao",
    pronunciation: "Thăm-may",
    category: "Từ để hỏi",
  },
  {
    id: 369,
    thai: "อย่างไร",
    vietnamese: "Như thế nào",
    pronunciation: "Yàng-ray",
    category: "Từ để hỏi",
  },
  {
    id: 370,
    thai: "มาก",
    vietnamese: "Rất / Nhiều",
    pronunciation: "Mạc",
    category: "Phó từ",
  },
  {
    id: 371,
    thai: "น้อย",
    vietnamese: "Ít",
    pronunciation: "Nói",
    category: "Phó từ",
  },
  {
    id: 372,
    thai: "ทั้งหมด",
    vietnamese: "Tất cả",
    pronunciation: "Thắng-mốt",
    category: "Lượng từ",
  },
  {
    id: 373,
    thai: "บางครั้ง",
    vietnamese: "Thỉnh thoảng",
    pronunciation: "Bang-kh-rắng",
    category: "Phó từ",
  },
  {
    id: 374,
    thai: "เสมอ",
    vietnamese: "Luôn luôn",
    pronunciation: "Sa-mở",
    category: "Phó từ",
  },
  {
    id: 375,
    thai: "ไม่เคย",
    vietnamese: "Chưa từng",
    pronunciation: "Mai-khơi",
    category: "Phó từ",
  },
  {
    id: 376,
    thai: "เคย",
    vietnamese: "Đã từng",
    pronunciation: "Khơi",
    category: "Phó từ",
  },
  {
    id: 377,
    thai: "กำลัง",
    vietnamese: "Đang (tiếp diễn)",
    pronunciation: "Kam-lang",
    category: "Ngữ pháp",
  },
  {
    id: 378,
    thai: "จะ",
    vietnamese: "Sẽ",
    pronunciation: "Chạ",
    category: "Ngữ pháp",
  },
  {
    id: 379,
    thai: "ได้",
    vietnamese: "Được (có thể)",
    pronunciation: "Đai",
    category: "Ngữ pháp",
  },
  {
    id: 380,
    thai: "ต้อง",
    vietnamese: "Phải",
    pronunciation: "Toọng",
    category: "Ngữ pháp",
  },
  {
    id: 381,
    thai: "อยาก",
    vietnamese: "Muốn",
    pronunciation: "Dạc",
    category: "Ngữ pháp",
  },
  {
    id: 382,
    thai: "คน",
    vietnamese: "Người (danh từ / lượng từ)",
    pronunciation: "Khon",
    category: "Danh từ",
  },
  {
    id: 383,
    thai: "ตัว",
    vietnamese: "Con (lượng từ vật)",
    pronunciation: "Tua",
    category: "Lượng từ",
  },
  {
    id: 384,
    thai: "อัน",
    vietnamese: "Cái (lượng từ đồ vật)",
    pronunciation: "Ăn",
    category: "Lượng từ",
  },
  {
    id: 385,
    thai: "ชิ้น",
    vietnamese: "Miếng / Mảnh",
    pronunciation: "Chín",
    category: "Lượng từ",
  },
  {
    id: 386,
    thai: "ประเทศ",
    vietnamese: "Đất nước",
    pronunciation: "Pra-thết",
    category: "Địa điểm",
  },
  {
    id: 387,
    thai: "ไทย",
    vietnamese: "Thái Lan",
    pronunciation: "Thay",
    category: "Địa điểm",
  },
  {
    id: 388,
    thai: "เวียดนาม",
    vietnamese: "Việt Nam",
    pronunciation: "Wiệt-nam",
    category: "Địa điểm",
  },
  {
    id: 389,
    thai: "จีน",
    vietnamese: "Trung Quốc",
    pronunciation: "Chin",
    category: "Địa điểm",
  },
  {
    id: 390,
    thai: "อังกฤษ",
    vietnamese: "Anh",
    pronunciation: "Ăng-krịt",
    category: "Địa điểm",
  },
  {
    id: 391,
    thai: "ภาษา",
    vietnamese: "Ngôn ngữ",
    pronunciation: "Pha-sả",
    category: "Danh từ",
  },
  {
    id: 392,
    thai: "ชื่อ",
    vietnamese: "Tên",
    pronunciation: "Chứ",
    category: "Danh từ",
  },
  {
    id: 393,
    thai: "นามสกุล",
    vietnamese: "Họ",
    pronunciation: "Nam-sa-kun",
    category: "Danh từ",
  },
  {
    id: 394,
    thai: "อายุ",
    vietnamese: "Tuổi",
    pronunciation: "A-yụ",
    category: "Danh từ",
  },
  {
    id: 395,
    thai: "เบอร์โทรศัพท์",
    vietnamese: "Số điện thoại",
    pronunciation: "Bơ-thô-ra-sắp",
    category: "Danh từ",
  },
  {
    id: 396,
    thai: "ที่อยู่",
    vietnamese: "Địa chỉ",
    pronunciation: "Thi-yu",
    category: "Danh từ",
  },
  {
    id: 397,
    thai: "วันเกิด",
    vietnamese: "Sinh nhật",
    pronunciation: "Văn-kợt",
    category: "Danh từ",
  },
  {
    id: 398,
    thai: "ความรัก",
    vietnamese: "Tình yêu",
    pronunciation: "Khoam-rắc",
    category: "Danh từ",
  },
  {
    id: 399,
    thai: "เพื่อน",
    vietnamese: "Bạn bè",
    pronunciation: "Phườn",
    category: "Danh từ",
  },
  {
    id: 400,
    thai: "สนุก",
    vietnamese: "Vui",
    pronunciation: "Sa-nục",
    category: "Tính từ",
  },
  {
    id: 401,
    thai: "น่ารัก",
    vietnamese: "Dễ thương",
    pronunciation: "Na-rắc",
    category: "Tính từ",
  },
  {
    id: 402,
    thai: "เก่ง",
    vietnamese: "Giỏi",
    pronunciation: "Kềng",
    category: "Tính từ",
  },
  {
    id: 403,
    thai: "แย่",
    vietnamese: "Tệ",
    pronunciation: "Dè",
    category: "Tính từ",
  },
  {
    id: 404,
    thai: "จริง",
    vietnamese: "Thật",
    pronunciation: "Ching",
    category: "Tính từ",
  },
  {
    id: 405,
    thai: "เล่นกีฬา",
    vietnamese: "Chơi thể thao",
    pronunciation: "Lên-ki-la",
    category: "Động từ",
  },
  {
    id: 406,
    thai: "ฟุตบอล",
    vietnamese: "Bóng đá",
    pronunciation: "Phút-bon",
    category: "Thể thao",
  },
  {
    id: 407,
    thai: "ว่ายน้ำ",
    vietnamese: "Bơi lội",
    pronunciation: "Wai-nám",
    category: "Thể thao",
  },
  {
    id: 408,
    thai: "วิ่งเล่น",
    vietnamese: "Chạy chơi",
    pronunciation: "Ving-lên",
    category: "Động từ",
  },
  {
    id: 409,
    thai: "ดูหนัง",
    vietnamese: "Xem phim",
    pronunciation: "Đu-nẳng",
    category: "Động từ",
  },
  {
    id: 410,
    thai: "ฟังเพลง",
    vietnamese: "Nghe nhạc",
    pronunciation: "Phăng-phlêng",
    category: "Động từ",
  },
  {
    id: 411,
    thai: "ร้องเพลง",
    vietnamese: "Hát",
    pronunciation: "Rọng-phlêng",
    category: "Động từ",
  },
  {
    id: 412,
    thai: "ถ่ายรูป",
    vietnamese: "Chụp ảnh",
    pronunciation: "Thài-rup",
    category: "Động từ",
  },
  {
    id: 413,
    thai: "วาดรูป",
    vietnamese: "Vẽ tranh",
    pronunciation: "Wát-rup",
    category: "Động từ",
  },
  {
    id: 414,
    thai: "เต้น",
    vietnamese: "Nhảy múa",
    pronunciation: "Tên",
    category: "Động từ",
  },
  {
    id: 415,
    thai: "หนังสือ",
    vietnamese: "Sách",
    pronunciation: "Nẳng-sử",
    category: "Danh từ",
  },
  {
    id: 416,
    thai: "ปากกา",
    vietnamese: "Bút bi",
    pronunciation: "Pạc-ka",
    category: "Danh từ",
  },
  {
    id: 417,
    thai: "ดินสอ",
    vietnamese: "Bút chì",
    pronunciation: "Đin-sỏ",
    category: "Danh từ",
  },
  {
    id: 418,
    thai: "กระดาษ",
    vietnamese: "Giấy",
    pronunciation: "Kra-đạt",
    category: "Danh từ",
  },
  {
    id: 419,
    thai: "คอมพิวเตอร์",
    vietnamese: "Máy tính",
    pronunciation: "Com-phiu-tơ",
    category: "Danh từ",
  },
  {
    id: 420,
    thai: "อินเทอร์เน็ต",
    vietnamese: "Internet",
    pronunciation: "In-thơ-nét",
    category: "Danh từ",
  },
  {
    id: 421,
    thai: "ผัว",
    vietnamese: "Chồng (thân mật)",
    pronunciation: "Phủa",
    category: "Gia đình",
  },
  {
    id: 422,
    thai: "เมีย",
    vietnamese: "Vợ (thân mật)",
    pronunciation: "Mia",
    category: "Gia đình",
  },
  {
    id: 423,
    thai: "สามี",
    vietnamese: "Chồng (lịch sự)",
    pronunciation: "Sả-mi",
    category: "Gia đình",
  },
  {
    id: 424,
    thai: "ภรรยา",
    vietnamese: "Vợ (lịch sự)",
    pronunciation: "Phăn-ra-ya",
    category: "Gia đình",
  },
  {
    id: 425,
    thai: "ลูก",
    vietnamese: "Con",
    pronunciation: "Lục",
    category: "Gia đình",
  },
  {
    id: 426,
    thai: "ลูกชาย",
    vietnamese: "Con trai",
    pronunciation: "Lục-chai",
    category: "Gia đình",
  },
  {
    id: 427,
    thai: "ลูกสาว",
    vietnamese: "Con gái",
    pronunciation: "Lục-sảo",
    category: "Gia đình",
  },
  {
    id: 428,
    thai: "ปู่",
    vietnamese: "Ông nội",
    pronunciation: "Pù",
    category: "Gia đình",
  },
  {
    id: 429,
    thai: "ย่า",
    vietnamese: "Bà nội",
    pronunciation: "Dà",
    category: "Gia đình",
  },
  {
    id: 430,
    thai: "ตา",
    vietnamese: "Ông ngoại",
    pronunciation: "Ta",
    category: "Gia đình",
  },
  {
    id: 431,
    thai: "ยาย",
    vietnamese: "Bà ngoại",
    pronunciation: "Yai",
    category: "Gia đình",
  },
  {
    id: 432,
    thai: "ลุง",
    vietnamese: "Bác (trai)",
    pronunciation: "Lung",
    category: "Gia đình",
  },
  {
    id: 433,
    thai: "ป้า",
    vietnamese: "Bác (gái)",
    pronunciation: "Pạ",
    category: "Gia đình",
  },
  {
    id: 434,
    thai: "น้า",
    vietnamese: "Dì / Cậu (em mẹ)",
    pronunciation: "Nạ",
    category: "Gia đình",
  },
  {
    id: 435,
    thai: "อา",
    vietnamese: "Cô / Chú (em bố)",
    pronunciation: "A",
    category: "Gia đình",
  },
  {
    id: 436,
    thai: "หลาน",
    vietnamese: "Cháu",
    pronunciation: "Lản",
    category: "Gia đình",
  },
  {
    id: 437,
    thai: "ญาติ",
    vietnamese: "Họ hàng",
    pronunciation: "Yạt",
    category: "Gia đình",
  },
  {
    id: 438,
    thai: "เพื่อนบ้าน",
    vietnamese: "Hàng xóm",
    pronunciation: "Phườn-bán",
    category: "Gia đình",
  },
  {
    id: 439,
    thai: "แต่งงาน",
    vietnamese: "Kết hôn",
    pronunciation: "Tèng-ngan",
    category: "Động từ",
  },
  {
    id: 440,
    thai: "หย่า",
    vietnamese: "Ly hôn",
    pronunciation: "Dà",
    category: "Động từ",
  },
  {
    id: 441,
    thai: "โสด",
    vietnamese: "Độc thân",
    pronunciation: "Sột",
    category: "Tính từ",
  },
  {
    id: 442,
    thai: "ผี",
    vietnamese: "Ma",
    pronunciation: "Phỉ",
    category: "Danh từ",
  },
  {
    id: 443,
    thai: "พระ",
    vietnamese: "Phật / Nhà sư",
    pronunciation: "Phra",
    category: "Danh từ",
  },
  {
    id: 444,
    thai: "ทำบุญ",
    vietnamese: "Làm công đức",
    pronunciation: "Thăm-bun",
    category: "Động từ",
  },
  {
    id: 445,
    thai: "ตักบาตร",
    vietnamese: "Cúng dường (bát)",
    pronunciation: "Tặc-bạt",
    category: "Động từ",
  },
  {
    id: 446,
    thai: "สวดมนต์",
    vietnamese: "Tụng kinh / Cầu nguyện",
    pronunciation: "Suột-môn",
    category: "Động từ",
  },
  {
    id: 447,
    thai: "สงกรานต์",
    vietnamese: "Lễ hội Songkran",
    pronunciation: "Sông-kran",
    category: "Văn hóa",
  },
  {
    id: 448,
    thai: "ลอยกระทง",
    vietnamese: "Lễ hội Loy Krathong",
    pronunciation: "Loi-kra-thông",
    category: "Văn hóa",
  },
  {
    id: 449,
    thai: "มวยไทย",
    vietnamese: "Muay Thái",
    pronunciation: "Muôi-thay",
    category: "Văn hóa",
  },
  {
    id: 450,
    thai: "นวดแผนไทย",
    vietnamese: "Massage Thái",
    pronunciation: "Nuột-phẻn-thay",
    category: "Văn hóa",
  },
  {
    id: 451,
    thai: "รถทัวร์",
    vietnamese: "Xe khách (xe tour)",
    pronunciation: "Rốt-thua",
    category: "Phương tiện",
  },
  {
    id: 452,
    thai: "มอเตอร์ไซค์",
    vietnamese: "Xe máy",
    pronunciation: "Mo-tơ-sai",
    category: "Phương tiện",
  },
  {
    id: 453,
    thai: "จักรยาน",
    vietnamese: "Xe đạp",
    pronunciation: "Chắc-ka-yan",
    category: "Phương tiện",
  },
  {
    id: 454,
    thai: "น้ำมัน",
    vietnamese: "Xăng / Dầu",
    pronunciation: "Nam-măn",
    category: "Phương tiện",
  },
  {
    id: 455,
    thai: "จอดรถ",
    vietnamese: "Đỗ xe",
    pronunciation: "Chọt-rốt",
    category: "Động từ",
  },
  {
    id: 456,
    thai: "ทางด่วน",
    vietnamese: "Đường cao tốc",
    pronunciation: "Thang-đuồn",
    category: "Địa điểm",
  },
  {
    id: 457,
    thai: "สะพาน",
    vietnamese: "Cầu",
    pronunciation: "Sa-phan",
    category: "Địa điểm",
  },
  {
    id: 458,
    thai: "ไฟแดง",
    vietnamese: "Đèn đỏ",
    pronunciation: "Phay-đeng",
    category: "Địa điểm",
  },
  {
    id: 459,
    thai: "ซอย",
    vietnamese: "Ngõ / Hẻm",
    pronunciation: "Soi",
    category: "Địa điểm",
  },
  {
    id: 460,
    thai: "ถนน",
    vietnamese: "Đường phố",
    pronunciation: "Tha-nổn",
    category: "Địa điểm",
  },
  {
    id: 461,
    thai: "บัตร",
    vietnamese: "Thẻ",
    pronunciation: "Bặt",
    category: "Danh từ",
  },
  {
    id: 462,
    thai: "บัตรเครดิต",
    vietnamese: "Thẻ tín dụng",
    pronunciation: "Bặt-khre-địt",
    category: "Danh từ",
  },
  {
    id: 463,
    thai: "เงินสด",
    vietnamese: "Tiền mặt",
    pronunciation: "Ngơn-sốt",
    category: "Danh từ",
  },
  {
    id: 464,
    thai: "ใบเสร็จ",
    vietnamese: "Hóa đơn",
    pronunciation: "Bay-sệt",
    category: "Danh từ",
  },
  {
    id: 465,
    thai: "ภาษี",
    vietnamese: "Thuế",
    pronunciation: "Pha-sỉ",
    category: "Danh từ",
  },
  {
    id: 466,
    thai: "บริษัท",
    vietnamese: "Công ty",
    pronunciation: "Bo-ri-sặt",
    category: "Danh từ",
  },
  {
    id: 467,
    thai: "เจ้านาย",
    vietnamese: "Sếp / Ông chủ",
    pronunciation: "Chao-nai",
    category: "Danh từ",
  },
  {
    id: 468,
    thai: "ลูกน้อง",
    vietnamese: "Nhân viên cấp dưới",
    pronunciation: "Lục-noong",
    category: "Danh từ",
  },
  {
    id: 469,
    thai: "ประชุม",
    vietnamese: "Họp",
    pronunciation: "Pra-chum",
    category: "Động từ",
  },
  {
    id: 470,
    thai: "ลาพักร้อน",
    vietnamese: "Nghỉ phép",
    pronunciation: "La-phắc-rón",
    category: "Động từ",
  },
  {
    id: 471,
    thai: "เงินเดือน",
    vietnamese: "Lương",
    pronunciation: "Ngơn-đươn",
    category: "Danh từ",
  },
  {
    id: 472,
    thai: "โบนัส",
    vietnamese: "Tiền thưởng (Bonus)",
    pronunciation: "Bô-nắt",
    category: "Danh từ",
  },
  {
    id: 473,
    thai: "สัมภาษณ์",
    vietnamese: "Phỏng vấn",
    pronunciation: "Sắm-phạt",
    category: "Động từ",
  },
  {
    id: 474,
    thai: "สมัครงาน",
    vietnamese: "Xin việc",
    pronunciation: "Sa-mặc-ngan",
    category: "Động từ",
  },
  {
    id: 475,
    thai: "ลาออก",
    vietnamese: "Thôi việc / Từ chức",
    pronunciation: "La-ọc",
    category: "Động từ",
  },
  {
    id: 476,
    thai: "ไล่ออก",
    vietnamese: "Sa thải",
    pronunciation: "Lai-ọc",
    category: "Động từ",
  },
  {
    id: 477,
    thai: "เกษียณ",
    vietnamese: "Nghỉ hưu",
    pronunciation: "Ka-sỉan",
    category: "Động từ",
  },
  {
    id: 478,
    thai: "สำเร็จ",
    vietnamese: "Thành công",
    pronunciation: "Sẳm-rệt",
    category: "Tính từ",
  },
  {
    id: 479,
    thai: "ล้มเหลว",
    vietnamese: "Thất bại",
    pronunciation: "Lốm-lểu",
    category: "Tính từ",
  },
  {
    id: 480,
    thai: "พยายาม",
    vietnamese: "Cố gắng",
    pronunciation: "Pha-ya-yam",
    category: "Động từ",
  },
  {
    id: 481,
    thai: "อดทน",
    vietnamese: "Kiên nhẫn",
    pronunciation: "Ốt-thon",
    category: "Tính từ",
  },
  {
    id: 482,
    thai: "ขี้เกียจ",
    vietnamese: "Lười biếng",
    pronunciation: "Khị-kiệt",
    category: "Tính từ",
  },
  {
    id: 483,
    thai: "ขยัน",
    vietnamese: "Chăm chỉ",
    pronunciation: "Kha-yẳn",
    category: "Tính từ",
  },
  {
    id: 484,
    thai: "สุภาพ",
    vietnamese: "Lịch sự",
    pronunciation: "Su-phạp",
    category: "Tính từ",
  },
  {
    id: 485,
    thai: "หยาบคาย",
    vietnamese: "Thô lỗ",
    pronunciation: "Dạp-khai",
    category: "Tính từ",
  },
  {
    id: 486,
    thai: "ใจดี",
    vietnamese: "Tốt bụng",
    pronunciation: "Chai-đi",
    category: "Tính từ",
  },
  {
    id: 487,
    thai: "ใจร้าย",
    vietnamese: "Độc ác / Xấu tính",
    pronunciation: "Chai-rái",
    category: "Tính từ",
  },
  {
    id: 488,
    thai: "ขี้เหนียว",
    vietnamese: "Keo kiệt",
    pronunciation: "Khị-niểu",
    category: "Tính từ",
  },
  {
    id: 489,
    thai: "กล้าหาญ",
    vietnamese: "Dũng cảm",
    pronunciation: "Kla-hản",
    category: "Tính từ",
  },
  {
    id: 490,
    thai: "ขี้ขลาด",
    vietnamese: "Nhút nhát",
    pronunciation: "Khị-khlạt",
    category: "Tính từ",
  },
  {
    id: 491,
    thai: "ซื่อสัตย์",
    vietnamese: "Trung thực",
    pronunciation: "Sứ-sặt",
    category: "Tính từ",
  },
  {
    id: 492,
    thai: "โกหก",
    vietnamese: "Nói dối",
    pronunciation: "Kô-hộc",
    category: "Động từ",
  },
  {
    id: 493,
    thai: "ความลับ",
    vietnamese: "Bí mật",
    pronunciation: "Khoam-lắp",
    category: "Danh từ",
  },
  {
    id: 494,
    thai: "ปัญหา",
    vietnamese: "Vấn đề",
    pronunciation: "Păn-hả",
    category: "Danh từ",
  },
  {
    id: 495,
    thai: "ทางออก",
    vietnamese: "Lối ra / Giải pháp",
    pronunciation: "Thang-ọc",
    category: "Danh từ",
  },
  {
    id: 496,
    thai: "ความหวัง",
    vietnamese: "Hy vọng",
    pronunciation: "Khoam-wẳng",
    category: "Danh từ",
  },
  {
    id: 497,
    thai: "ความฝัน",
    vietnamese: "Giấc mơ",
    pronunciation: "Khoam-phẳn",
    category: "Danh từ",
  },
  {
    id: 498,
    thai: "ความจริง",
    vietnamese: "Sự thật",
    pronunciation: "Khoam-ching",
    category: "Danh từ",
  },
  {
    id: 499,
    thai: "ชีวิต",
    vietnamese: "Cuộc sống",
    pronunciation: "Chi-wít",
    category: "Danh từ",
  },
  {
    id: 500,
    thai: "ตาย",
    vietnamese: "Chết",
    pronunciation: "Tai",
    category: "Động từ",
  },
];

export const conversations: IConversation[] = [
  // --- SCENARIO 1: LÀM QUEN (INTRO) ---
  {
    id: 1,
    role: "A",
    speaker: "Nam",
    thai: "สวัสดีครับ คุณชื่ออะไร?",
    vietnamese: "Xin chào, bạn tên là gì?",
    scenario: "Làm quen",
  },
  {
    id: 2,
    role: "B",
    speaker: "Mai",
    thai: "ฉันชื่อใหม่ค่ะ ยินดีที่ได้รู้จัก",
    vietnamese: "Tôi tên Mai. Rất vui được làm quen.",
    scenario: "Làm quen",
  },
  {
    id: 3,
    role: "A",
    speaker: "Nam",
    thai: "คุณสบายดีไหม?",
    vietnamese: "Bạn có khỏe không?",
    scenario: "Làm quen",
  },
  {
    id: 4,
    role: "B",
    speaker: "Mai",
    thai: "สบายดีค่ะ แล้วคุณล่ะ?",
    vietnamese: "Tôi khỏe, còn bạn thì sao?",
    scenario: "Làm quen",
  },
  {
    id: 5,
    role: "A",
    speaker: "Nam",
    thai: "ผมก็สบายดีครับ",
    vietnamese: "Tôi cũng khỏe ạ.",
    scenario: "Làm quen",
  },
  {
    id: 6,
    role: "A",
    speaker: "Nam",
    thai: "คุณมาจากไหนครับ?",
    vietnamese: "Bạn đến từ đâu?",
    scenario: "Làm quen",
  },
  {
    id: 7,
    role: "B",
    speaker: "Mai",
    thai: "ฉันมาจากเวียดนามค่ะ",
    vietnamese: "Tôi đến từ Việt Nam.",
    scenario: "Làm quen",
  },
  {
    id: 8,
    role: "A",
    speaker: "Nam",
    thai: "คุณพูดภาษาไทยเก่งมาก",
    vietnamese: "Bạn nói tiếng Thái giỏi quá.",
    scenario: "Làm quen",
  },
  {
    id: 9,
    role: "B",
    speaker: "Mai",
    thai: "ขอบคุณค่ะ ฉันกำลังเรียนอยู่",
    vietnamese: "Cảm ơn ạ, tôi đang học thôi.",
    scenario: "Làm quen",
  },
  {
    id: 10,
    role: "A",
    speaker: "Nam",
    thai: "ขอให้โชคดีนะครับ",
    vietnamese: "Chúc bạn may mắn nhé.",
    scenario: "Làm quen",
  },

  // --- SCENARIO 2: ĐI TAXI (TAXI) ---
  {
    id: 11,
    role: "A",
    speaker: "Khách",
    thai: "ไปสุขุมวิทซอย 11 ครับ",
    vietnamese: "Đi đến ngõ 11 Sukhumvit nhé.",
    scenario: "Đi taxi",
  },
  {
    id: 12,
    role: "B",
    speaker: "Tài xế",
    thai: "ได้ครับ ขึ้นมาเลย",
    vietnamese: "Được chứ, mời lên xe.",
    scenario: "Đi taxi",
  },
  {
    id: 13,
    role: "A",
    speaker: "Khách",
    thai: "ไกลไหมครับ?",
    vietnamese: "Có xa không anh?",
    scenario: "Đi taxi",
  },
  {
    id: 14,
    role: "B",
    speaker: "Tài xế",
    thai: "ไม่ไกลครับ ประมาณ 15 นาที",
    vietnamese: "Không xa đâu, khoảng 15 phút.",
    scenario: "Đi taxi",
  },
  {
    id: 15,
    role: "A",
    speaker: "Khách",
    thai: "เลี้ยวซ้ายข้างหน้าครับ",
    vietnamese: "Rẽ trái phía trước nhé.",
    scenario: "Đi taxi",
  },
  {
    id: 16,
    role: "A",
    speaker: "Khách",
    thai: "แล้วตรงไปครับ",
    vietnamese: "Sau đó đi thẳng.",
    scenario: "Đi taxi",
  },
  {
    id: 17,
    role: "A",
    speaker: "Khách",
    thai: "จอดตรงนี้ครับ",
    vietnamese: "Dừng ở đây ạ.",
    scenario: "Đi taxi",
  },
  {
    id: 18,
    role: "A",
    speaker: "Khách",
    thai: "เท่าไหร่ครับ?",
    vietnamese: "Bao nhiêu tiền vậy?",
    scenario: "Đi taxi",
  },
  {
    id: 19,
    role: "B",
    speaker: "Tài xế",
    thai: "100 บาทครับ",
    vietnamese: "100 Baht ạ.",
    scenario: "Đi taxi",
  },
  {
    id: 20,
    role: "A",
    speaker: "Khách",
    thai: "นี่ครับ ขอบคุณครับ",
    vietnamese: "Đây ạ, cảm ơn anh.",
    scenario: "Đi taxi",
  },

  // --- SCENARIO 3: NHÀ HÀNG (RESTAURANT) ---
  {
    id: 21,
    role: "A",
    speaker: "Khách",
    thai: "ขอเมนูหน่อยครับ",
    vietnamese: "Cho tôi xin menu với.",
    scenario: "Nhà hàng",
  },
  {
    id: 22,
    role: "B",
    speaker: "Phục vụ",
    thai: "นี่ค่ะ รับอะไรดีคะ?",
    vietnamese: "Đây ạ. Quý khách dùng gì ạ?",
    scenario: "Nhà hàng",
  },
  {
    id: 23,
    role: "A",
    speaker: "Khách",
    thai: "เอาข้าวผัดกุ้งครับ",
    vietnamese: "Cho tôi cơm rang tôm.",
    scenario: "Nhà hàng",
  },
  {
    id: 24,
    role: "A",
    speaker: "Khách",
    thai: "ไม่เผ็ดนะครับ",
    vietnamese: "Không cay nhé.",
    scenario: "Nhà hàng",
  },
  {
    id: 25,
    role: "B",
    speaker: "Phục vụ",
    thai: "รับเครื่องดื่มอะไรไหมคะ?",
    vietnamese: "Quý khách uống gì không ạ?",
    scenario: "Nhà hàng",
  },
  {
    id: 26,
    role: "A",
    speaker: "Khách",
    thai: "ขอน้ำเปล่า 1 ขวดครับ",
    vietnamese: "Cho 1 chai nước lọc.",
    scenario: "Nhà hàng",
  },
  {
    id: 27,
    role: "A",
    speaker: "Khách",
    thai: "อาหารอร่อยมาก",
    vietnamese: "Đồ ăn ngon lắm.",
    scenario: "Nhà hàng",
  },
  {
    id: 28,
    role: "A",
    speaker: "Khách",
    thai: "เก็บเงินด้วยครับ",
    vietnamese: "Tính tiền cho tôi với.",
    scenario: "Nhà hàng",
  },
  {
    id: 29,
    role: "B",
    speaker: "Phục vụ",
    thai: "ทั้งหมด 250 บาทค่ะ",
    vietnamese: "Tổng cộng 250 Baht ạ.",
    scenario: "Nhà hàng",
  },
  {
    id: 30,
    role: "A",
    speaker: "Khách",
    thai: "ไม่ต้องทอนครับ",
    vietnamese: "Không cần thối lại đâu (Bo).",
    scenario: "Nhà hàng",
  },

  // --- SCENARIO 4: MUA SẮM (SHOPPING) ---
  {
    id: 31,
    role: "A",
    speaker: "Khách",
    thai: "อันนี้เท่าไหร่คะ?",
    vietnamese: "Cái này bao nhiêu tiền?",
    scenario: "Mua sắm",
  },
  {
    id: 32,
    role: "B",
    speaker: "Chủ quán",
    thai: "อันนี้ 500 บาทครับ",
    vietnamese: "Cái này 500 Baht.",
    scenario: "Mua sắm",
  },
  {
    id: 33,
    role: "A",
    speaker: "Khách",
    thai: "แพงจัง ลดได้ไหม?",
    vietnamese: "Đắt quá, giảm giá được không?",
    scenario: "Mua sắm",
  },
  {
    id: 34,
    role: "B",
    speaker: "Chủ quán",
    thai: "ลดได้นิดหน่อยครับ",
    vietnamese: "Giảm được một chút thôi.",
    scenario: "Mua sắm",
  },
  {
    id: 35,
    role: "A",
    speaker: "Khách",
    thai: "400 บาทได้ไหม?",
    vietnamese: "400 Baht được không?",
    scenario: "Mua sắm",
  },
  {
    id: 36,
    role: "B",
    speaker: "Chủ quán",
    thai: "ไม่ได้ครับ ขาดทุน",
    vietnamese: "Không được đâu, lỗ vốn.",
    scenario: "Mua sắm",
  },
  {
    id: 37,
    role: "A",
    speaker: "Khách",
    thai: "งั้น 450 บาทนะ",
    vietnamese: "Vậy 450 Baht nhé.",
    scenario: "Mua sắm",
  },
  {
    id: 38,
    role: "B",
    speaker: "Chủ quán",
    thai: "ก็ได้ครับ เอาสีอะไร?",
    vietnamese: "Cũng được. Lấy màu gì?",
    scenario: "Mua sắm",
  },
  {
    id: 39,
    role: "A",
    speaker: "Khách",
    thai: "เอาสีแดงค่ะ",
    vietnamese: "Lấy màu đỏ ạ.",
    scenario: "Mua sắm",
  },
  {
    id: 40,
    role: "A",
    speaker: "Khách",
    thai: "มีถุงไหมคะ?",
    vietnamese: "Có túi không ạ?",
    scenario: "Mua sắm",
  },

  // --- SCENARIO 5: TÌNH HUỐNG KHẨN CẤP / CƠ BẢN (EMERGENCY) ---
  {
    id: 41,
    role: "A",
    speaker: "Du khách",
    thai: "ขอโทษครับ ห้องน้ำอยู่ไหน?",
    vietnamese: "Xin lỗi, nhà vệ sinh ở đâu?",
    scenario: "Hỏi đường",
  },
  {
    id: 42,
    role: "B",
    speaker: "Người dân",
    thai: "อยู่ทางโน้นครับ",
    vietnamese: "Ở đằng kia kìa.",
    scenario: "Hỏi đường",
  },
  {
    id: 43,
    role: "A",
    speaker: "Du khách",
    thai: "คุณพูดภาษาอังกฤษได้ไหม?",
    vietnamese: "Bạn có nói tiếng Anh được không?",
    scenario: "Cơ bản",
  },
  {
    id: 44,
    role: "B",
    speaker: "Người dân",
    thai: "ได้นิดหน่อยครับ",
    vietnamese: "Được một chút thôi.",
    scenario: "Cơ bản",
  },
  {
    id: 45,
    role: "A",
    speaker: "Du khách",
    thai: "ช่วยด้วย!",
    vietnamese: "Cứu với / Giúp tôi với!",
    scenario: "Khẩn cấp",
  },
  {
    id: 46,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันไม่เข้าใจ",
    vietnamese: "Tôi không hiểu.",
    scenario: "Cơ bản",
  },
  {
    id: 47,
    role: "A",
    speaker: "Du khách",
    thai: "พูดช้าๆ หน่อยได้ไหม?",
    vietnamese: "Nói chậm lại một chút được không?",
    scenario: "Cơ bản",
  },
  {
    id: 48,
    role: "A",
    speaker: "Du khách",
    thai: "โรงพยาบาลอยู่ที่ไหน?",
    vietnamese: "Bệnh viện ở đâu?",
    scenario: "Khẩn cấp",
  },
  {
    id: 49,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันหลงทาง",
    vietnamese: "Tôi bị lạc đường.",
    scenario: "Khẩn cấp",
  },
  {
    id: 50,
    role: "B",
    speaker: "Cảnh sát",
    thai: "ไม่ต้องห่วง ผมจะช่วยคุณ",
    vietnamese: "Đừng lo, tôi sẽ giúp bạn.",
    scenario: "Khẩn cấp",
  },
  // --- SCENARIO 6: MUA SIM & INTERNET (CÔNG NGHỆ) ---
  {
    id: 51,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันอยากซื้อซิมการ์ด",
    vietnamese: "Tôi muốn mua SIM điện thoại.",
    scenario: "Mua SIM",
  },
  {
    id: 52,
    role: "B",
    speaker: "Nhân viên",
    thai: "อยู่กี่วันครับ?",
    vietnamese: "Bạn ở lại bao nhiêu ngày?",
    scenario: "Mua SIM",
  },
  {
    id: 53,
    role: "A",
    speaker: "Du khách",
    thai: "อยู่ 5 วันครับ",
    vietnamese: "Tôi ở 5 ngày.",
    scenario: "Mua SIM",
  },
  {
    id: 54,
    role: "B",
    speaker: "Nhân viên",
    thai: "เอาเน็ตไม่จำกัดไหม?",
    vietnamese: "Lấy gói mạng không giới hạn nhé?",
    scenario: "Mua SIM",
  },
  {
    id: 55,
    role: "A",
    speaker: "Du khách",
    thai: "ดีครับ ราคาเท่าไหร่?",
    vietnamese: "Được ạ. Giá bao nhiêu?",
    scenario: "Mua SIM",
  },
  {
    id: 56,
    role: "B",
    speaker: "Nhân viên",
    thai: "299 บาทครับ",
    vietnamese: "299 Baht ạ.",
    scenario: "Mua SIM",
  },
  {
    id: 57,
    role: "A",
    speaker: "Du khách",
    thai: "อินเทอร์เน็ตเร็วไหม?",
    vietnamese: "Mạng có nhanh không?",
    scenario: "Mua SIM",
  },
  {
    id: 58,
    role: "B",
    speaker: "Nhân viên",
    thai: "เร็วมากครับ 5G",
    vietnamese: "Rất nhanh, sóng 5G.",
    scenario: "Mua SIM",
  },
  {
    id: 59,
    role: "A",
    speaker: "Du khách",
    thai: "ช่วยเปลี่ยนซิมให้หน่อย",
    vietnamese: "Giúp tôi thay SIM với.",
    scenario: "Mua SIM",
  },
  {
    id: 60,
    role: "B",
    speaker: "Nhân viên",
    thai: "ได้ครับ เรียบร้อย",
    vietnamese: "Được ạ. Xong rồi đây.",
    scenario: "Mua SIM",
  },

  // --- SCENARIO 7: KHÁCH SẠN (HOTEL CHECK-IN) ---
  {
    id: 61,
    role: "A",
    speaker: "Du khách",
    thai: "เช็คอินครับ",
    vietnamese: "Cho tôi làm thủ tục nhận phòng.",
    scenario: "Khách sạn",
  },
  {
    id: 62,
    role: "B",
    speaker: "Lễ tân",
    thai: "จองไว้ไหมคะ?",
    vietnamese: "Quý khách có đặt trước không?",
    scenario: "Khách sạn",
  },
  {
    id: 63,
    role: "A",
    speaker: "Du khách",
    thai: "จองผ่าน Agoda ครับ",
    vietnamese: "Tôi đặt qua Agoda rồi.",
    scenario: "Khách sạn",
  },
  {
    id: 64,
    role: "B",
    speaker: "Lễ tân",
    thai: "ขอดูพาสปอร์ตหน่อยค่ะ",
    vietnamese: "Cho tôi xem hộ chiếu với ạ.",
    scenario: "Khách sạn",
  },
  {
    id: 65,
    role: "A",
    speaker: "Du khách",
    thai: "รวมอาหารเช้าไหม?",
    vietnamese: "Có bao gồm bữa sáng không?",
    scenario: "Khách sạn",
  },
  {
    id: 66,
    role: "B",
    speaker: "Lễ tân",
    thai: "รวมค่ะ เริ่ม 6 โมงเช้า",
    vietnamese: "Có ạ. Bắt đầu lúc 6 giờ sáng.",
    scenario: "Khách sạn",
  },
  {
    id: 67,
    role: "A",
    speaker: "Du khách",
    thai: "ขอรหัสไวไฟด้วยครับ",
    vietnamese: "Cho tôi xin mật khẩu Wifi.",
    scenario: "Khách sạn",
  },
  {
    id: 68,
    role: "B",
    speaker: "Lễ tân",
    thai: "อยู่ในคีย์การ์ดค่ะ",
    vietnamese: "Nó ghi trên thẻ phòng ạ.",
    scenario: "Khách sạn",
  },
  {
    id: 69,
    role: "A",
    speaker: "Du khách",
    thai: "สระว่ายน้ำอยู่ชั้นไหน?",
    vietnamese: "Hồ bơi ở tầng mấy?",
    scenario: "Khách sạn",
  },
  {
    id: 70,
    role: "B",
    speaker: "Lễ tân",
    thai: "อยู่ชั้นดาดฟ้าค่ะ",
    vietnamese: "Ở trên tầng thượng ạ.",
    scenario: "Khách sạn",
  },

  // --- SCENARIO 8: THƯ GIÃN (MASSAGE) ---
  {
    id: 71,
    role: "A",
    speaker: "Du khách",
    thai: "นวดเท้าไหมครับ?",
    vietnamese: "Có massage chân không?",
    scenario: "Giải trí",
  },
  {
    id: 72,
    role: "B",
    speaker: "Nhân viên",
    thai: "มีค่ะ เชิญนั่งค่ะ",
    vietnamese: "Có ạ, mời ngồi.",
    scenario: "Giải trí",
  },
  {
    id: 73,
    role: "A",
    speaker: "Du khách",
    thai: "ชั่วโมงละเท่าไหร่?",
    vietnamese: "Bao nhiêu tiền một tiếng?",
    scenario: "Giải trí",
  },
  {
    id: 74,
    role: "B",
    speaker: "Nhân viên",
    thai: "200 บาทค่ะ",
    vietnamese: "200 Baht ạ.",
    scenario: "Giải trí",
  },
  {
    id: 75,
    role: "A",
    speaker: "Du khách",
    thai: "เอา 1 ชั่วโมงครับ",
    vietnamese: "Cho tôi làm 1 tiếng.",
    scenario: "Giải trí",
  },
  {
    id: 76,
    role: "B",
    speaker: "Nhân viên",
    thai: "เจ็บไหมคะ?",
    vietnamese: "Có đau không ạ?",
    scenario: "Giải trí",
  },
  {
    id: 77,
    role: "A",
    speaker: "Du khách",
    thai: "เจ็บนิดหน่อยครับ",
    vietnamese: "Hơi đau một chút.",
    scenario: "Giải trí",
  },
  {
    id: 78,
    role: "A",
    speaker: "Du khách",
    thai: "เบาๆ หน่อยครับ",
    vietnamese: "Làm nhẹ nhẹ thôi nhé.",
    scenario: "Giải trí",
  },
  {
    id: 79,
    role: "A",
    speaker: "Du khách",
    thai: "สบายมากครับ",
    vietnamese: "Thoải mái lắm.",
    scenario: "Giải trí",
  },
  {
    id: 80,
    role: "A",
    speaker: "Du khách",
    thai: "นี่ทิปครับ",
    vietnamese: "Đây là tiền bo.",
    scenario: "Giải trí",
  },

  // --- SCENARIO 9: THỜI TIẾT (WEATHER) ---
  {
    id: 81,
    role: "A",
    speaker: "Du khách",
    thai: "วันนี้อากาศดีไหม?",
    vietnamese: "Hôm nay thời tiết tốt không?",
    scenario: "Thời tiết",
  },
  {
    id: 82,
    role: "B",
    speaker: "Người dân",
    thai: "วันนี้ร้อนมาก",
    vietnamese: "Hôm nay nóng lắm.",
    scenario: "Thời tiết",
  },
  {
    id: 83,
    role: "A",
    speaker: "Du khách",
    thai: "ฝนจะตกไหม?",
    vietnamese: "Trời có mưa không?",
    scenario: "Thời tiết",
  },
  {
    id: 84,
    role: "B",
    speaker: "Người dân",
    thai: "น่าจะตกตอนเย็น",
    vietnamese: "Chắc là mưa vào buổi chiều tối.",
    scenario: "Thời tiết",
  },
  {
    id: 85,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันไม่ชอบฝน",
    vietnamese: "Tôi không thích mưa.",
    scenario: "Thời tiết",
  },
  {
    id: 86,
    role: "B",
    speaker: "Người dân",
    thai: "พกร่มไปด้วยนะ",
    vietnamese: "Nhớ mang theo ô nhé.",
    scenario: "Thời tiết",
  },
  {
    id: 87,
    role: "A",
    speaker: "Du khách",
    thai: "หนาวไหม?",
    vietnamese: "Có lạnh không?",
    scenario: "Thời tiết",
  },
  {
    id: 88,
    role: "B",
    speaker: "Người dân",
    thai: "ไม่หนาวเลย",
    vietnamese: "Không lạnh chút nào.",
    scenario: "Thời tiết",
  },
  {
    id: 89,
    role: "A",
    speaker: "Du khách",
    thai: "แดดแรงมาก",
    vietnamese: "Nắng gắt quá.",
    scenario: "Thời tiết",
  },
  {
    id: 90,
    role: "B",
    speaker: "Người dân",
    thai: "ระวังไม่สบายนะ",
    vietnamese: "Cẩn thận kẻo ốm nhé.",
    scenario: "Thời tiết",
  },

  // --- SCENARIO 10: HIỆU THUỐC (PHARMACY) ---
  {
    id: 91,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันปวดหัว มียาพาราไหม?",
    vietnamese: "Tôi bị đau đầu, có Paracetamol không?",
    scenario: "Hiệu thuốc",
  },
  {
    id: 92,
    role: "B",
    speaker: "Dược sĩ",
    thai: "มีครับ เอาแผงหนึ่งไหม?",
    vietnamese: "Có ạ. Lấy một vỉ nhé?",
    scenario: "Hiệu thuốc",
  },
  {
    id: 93,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันปวดท้องด้วย",
    vietnamese: "Tôi bị đau bụng nữa.",
    scenario: "Hiệu thuốc",
  },
  {
    id: 94,
    role: "B",
    speaker: "Dược sĩ",
    thai: "ท้องเสียหรือเปล่าครับ?",
    vietnamese: "Có bị tiêu chảy không?",
    scenario: "Hiệu thuốc",
  },
  {
    id: 95,
    role: "A",
    speaker: "Du khách",
    thai: "ใช่ครับ กินเผ็ดไปหน่อย",
    vietnamese: "Có, tôi ăn cay hơi nhiều.",
    scenario: "Hiệu thuốc",
  },
  {
    id: 96,
    role: "B",
    speaker: "Dược sĩ",
    thai: "เอายานี้ไป กินหลังอาหารนะ",
    vietnamese: "Lấy thuốc này đi, uống sau khi ăn.",
    scenario: "Hiệu thuốc",
  },
  {
    id: 97,
    role: "A",
    speaker: "Du khách",
    thai: "ขอบคุณครับ เท่าไหร่ครับ?",
    vietnamese: "Cảm ơn. Bao nhiêu tiền?",
    scenario: "Hiệu thuốc",
  },

  // --- SCENARIO 11: SÂN BAY (AIRPORT) ---
  {
    id: 98,
    role: "A",
    speaker: "Du khách",
    thai: "เคาน์เตอร์เช็คอินอยู่ที่ไหน?",
    vietnamese: "Quầy check-in ở đâu?",
    scenario: "Sân bay",
  },
  {
    id: 99,
    role: "B",
    speaker: "Nhân viên",
    thai: "สายการบินอะไรคะ?",
    vietnamese: "Hãng hàng không nào ạ?",
    scenario: "Sân bay",
  },
  {
    id: 100,
    role: "A",
    speaker: "Du khách",
    thai: "สายการบินไทยครับ",
    vietnamese: "Hãng Thai Airways.",
    scenario: "Sân bay",
  },
  {
    id: 101,
    role: "B",
    speaker: "Nhân viên",
    thai: "อยู่ทางขวา แถว J ค่ะ",
    vietnamese: "Ở phía bên phải, dãy J ạ.",
    scenario: "Sân bay",
  },
  {
    id: 102,
    role: "A",
    speaker: "Du khách",
    thai: "ขอบคุณครับ ตม. ไปทางไหน?",
    vietnamese: "Cảm ơn. Cục xuất nhập cảnh đi lối nào?",
    scenario: "Sân bay",
  },
  {
    id: 103,
    role: "B",
    speaker: "Nhân viên",
    thai: "ขึ้นบันไดเลื่อนไปชั้นบนค่ะ",
    vietnamese: "Đi thang cuốn lên tầng trên ạ.",
    scenario: "Sân bay",
  },

  // --- SCENARIO 12: KHEN NGỢI & XÃ GIAO (SOCIALIZING) ---
  {
    id: 104,
    role: "A",
    speaker: "Nam",
    thai: "คุณสวยมาก",
    vietnamese: "Bạn xinh đẹp quá.",
    scenario: "Xã giao",
  },
  {
    id: 105,
    role: "B",
    speaker: "Nữ",
    thai: "ขอบคุณค่ะ คุณก็หล่อ",
    vietnamese: "Cảm ơn ạ. Anh cũng đẹp trai.",
    scenario: "Xã giao",
  },
  {
    id: 106,
    role: "A",
    speaker: "Nam",
    thai: "ยิ้มของคุณน่ารัก",
    vietnamese: "Nụ cười của bạn rất dễ thương.",
    scenario: "Xã giao",
  },
  {
    id: 107,
    role: "B",
    speaker: "Nữ",
    thai: "ปากหวานจัง",
    vietnamese: "Khéo miệng quá nha (Ngọt ngào quá).",
    scenario: "Xã giao",
  },
  {
    id: 108,
    role: "A",
    speaker: "Nam",
    thai: "มีไลน์ไหมครับ?",
    vietnamese: "Bạn có dùng Line không?",
    scenario: "Xã giao",
  },
  {
    id: 109,
    role: "B",
    speaker: "Nữ",
    thai: "มีค่ะ นี่ไอดีไลน์ฉัน",
    vietnamese: "Có ạ. Đây là ID Line của tôi.",
    scenario: "Xã giao",
  },
  {
    id: 110,
    role: "A",
    speaker: "Nam",
    thai: "เดี๋ยวทักไปนะครับ",
    vietnamese: "Lát nữa tôi nhắn tin nhé.",
    scenario: "Xã giao",
  },

  // =================================================================
  // SCENARIO 13: CỬA HÀNG TIỆN LỢI (7-ELEVEN) - Rất phổ biến
  // =================================================================
  {
    id: 111,
    role: "A",
    speaker: "Khách",
    thai: "เวฟไหมครับ?",
    vietnamese: "Có hâm nóng (lò vi sóng) không?",
    scenario: "7-Eleven",
  },
  {
    id: 112,
    role: "B",
    speaker: "Nhân viên",
    thai: "เวฟค่ะ รอสักครู่นะคะ",
    vietnamese: "Có ạ. Đợi một chút nhé.",
    scenario: "7-Eleven",
  },
  {
    id: 113,
    role: "B",
    speaker: "Nhân viên",
    thai: "รับขนมจีบซาลาเปาเพิ่มไหมคะ?",
    vietnamese: "Có lấy thêm há cảo hay bánh bao không?",
    scenario: "7-Eleven",
  },
  {
    id: 114,
    role: "A",
    speaker: "Khách",
    thai: "ไม่ครับ ขอบคุณ",
    vietnamese: "Không, cảm ơn.",
    scenario: "7-Eleven",
  },
  {
    id: 115,
    role: "B",
    speaker: "Nhân viên",
    thai: "มีสมาชิก All Member ไหมคะ?",
    vietnamese: "Có thẻ thành viên All Member không?",
    scenario: "7-Eleven",
  },
  {
    id: 116,
    role: "A",
    speaker: "Khách",
    thai: "ไม่มีครับ",
    vietnamese: "Không có.",
    scenario: "7-Eleven",
  },
  {
    id: 117,
    role: "A",
    speaker: "Khách",
    thai: "บุหรี่ซองหนึ่งครับ",
    vietnamese: "Cho 1 bao thuốc lá.",
    scenario: "7-Eleven",
  },
  {
    id: 118,
    role: "B",
    speaker: "Nhân viên",
    thai: "ยี่ห้ออะไรคะ?",
    vietnamese: "Hiệu gì ạ?",
    scenario: "7-Eleven",
  },
  {
    id: 119,
    role: "A",
    speaker: "Khách",
    thai: "เอา LM เขียวครับ",
    vietnamese: "Lấy LM gói xanh lá.",
    scenario: "7-Eleven",
  },
  {
    id: 120,
    role: "B",
    speaker: "Nhân viên",
    thai: "ใส่ถุงไหมคะ?",
    vietnamese: "Có lấy túi không?",
    scenario: "7-Eleven",
  },

  // =================================================================
  // SCENARIO 14: QUÁN CÀ PHÊ (COFFEE SHOP)
  // =================================================================
  {
    id: 121,
    role: "A",
    speaker: "Khách",
    thai: "เอาอเมริกาโน่เย็นแก้วหนึ่งครับ",
    vietnamese: "Cho tôi 1 ly Americano đá.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 122,
    role: "B",
    speaker: "Nhân viên",
    thai: "หวานไหมคะ?",
    vietnamese: "Có uống ngọt không ạ?",
    scenario: "Quán Cà Phê",
  },
  {
    id: 123,
    role: "A",
    speaker: "Khách",
    thai: "ไม่หวานเลยครับ",
    vietnamese: "Không đường nhé.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 124,
    role: "A",
    speaker: "Khách",
    thai: "หวานน้อยครับ",
    vietnamese: "Ít đường thôi.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 125,
    role: "A",
    speaker: "Khách",
    thai: "เอาลาเต้ร้อน",
    vietnamese: "Cho 1 Latte nóng.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 126,
    role: "B",
    speaker: "Nhân viên",
    thai: "ทานนี่หรือกลับบ้านคะ?",
    vietnamese: "Uống ở đây hay mang về?",
    scenario: "Quán Cà Phê",
  },
  {
    id: 127,
    role: "A",
    speaker: "Khách",
    thai: "กลับบ้านครับ",
    vietnamese: "Mang về ạ.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 128,
    role: "A",
    speaker: "Khách",
    thai: "ขอรหัสไวไฟด้วยครับ",
    vietnamese: "Cho xin mật khẩu Wifi.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 129,
    role: "B",
    speaker: "Nhân viên",
    thai: "อยู่ท้ายใบเสร็จค่ะ",
    vietnamese: "Ở cuối hóa đơn đấy ạ.",
    scenario: "Quán Cà Phê",
  },
  {
    id: 130,
    role: "A",
    speaker: "Khách",
    thai: "ห้องน้ำไปทางไหนครับ?",
    vietnamese: "Nhà vệ sinh đi đường nào?",
    scenario: "Quán Cà Phê",
  },

  // =================================================================
  // SCENARIO 15: THUÊ XE MÁY (RENT MOTORBIKE)
  // =================================================================
  {
    id: 131,
    role: "A",
    speaker: "Du khách",
    thai: "เช่ารถมอเตอร์ไซค์วันละเท่าไหร่?",
    vietnamese: "Thuê xe máy 1 ngày bao nhiêu?",
    scenario: "Thuê xe",
  },
  {
    id: 132,
    role: "B",
    speaker: "Chủ xe",
    thai: "วันละ 300 บาทครับ",
    vietnamese: "300 Baht một ngày.",
    scenario: "Thuê xe",
  },
  {
    id: 133,
    role: "A",
    speaker: "Du khách",
    thai: "ต้องมัดจำไหม?",
    vietnamese: "Có cần đặt cọc không?",
    scenario: "Thuê xe",
  },
  {
    id: 134,
    role: "B",
    speaker: "Chủ xe",
    thai: "มัดจำ 2000 บาท หรือทิ้งพาสปอร์ตไว้",
    vietnamese: "Cọc 2000 Baht hoặc để lại hộ chiếu.",
    scenario: "Thuê xe",
  },
  {
    id: 135,
    role: "A",
    speaker: "Du khách",
    thai: "ขอมัดจำเงินสดครับ",
    vietnamese: "Cho tôi cọc tiền mặt đi.",
    scenario: "Thuê xe",
  },
  {
    id: 136,
    role: "B",
    speaker: "Chủ xe",
    thai: "เติมน้ำมันชนิดไหน?",
    vietnamese: "Đổ loại xăng nào?",
    scenario: "Thuê xe",
  },
  {
    id: 137,
    role: "B",
    speaker: "Chủ xe",
    thai: "แก๊สโซฮอล์ 91 หรือ 95 ครับ",
    vietnamese: "Gasohol 91 hoặc 95 nhé.",
    scenario: "Thuê xe",
  },
  {
    id: 138,
    role: "A",
    speaker: "Du khách",
    thai: "หมวกกันน็อคมีไหม?",
    vietnamese: "Có mũ bảo hiểm không?",
    scenario: "Thuê xe",
  },
  {
    id: 139,
    role: "B",
    speaker: "Chủ xe",
    thai: "มีให้ 2 ใบครับ",
    vietnamese: "Có 2 cái cho bạn.",
    scenario: "Thuê xe",
  },
  {
    id: 140,
    role: "A",
    speaker: "Du khách",
    thai: "ถ้ายางแตกทำยังไง?",
    vietnamese: "Nếu thủng lốp thì sao?",
    scenario: "Thuê xe",
  },

  // =================================================================
  // SCENARIO 16: ĐỔI TIỀN (MONEY EXCHANGE)
  // =================================================================
  {
    id: 141,
    role: "A",
    speaker: "Du khách",
    thai: "เรทเงินบาทวันนี้เท่าไหร่?",
    vietnamese: "Tỷ giá tiền Baht hôm nay bao nhiêu?",
    scenario: "Đổi tiền",
  },
  {
    id: 142,
    role: "B",
    speaker: "Nhân viên",
    thai: "1 ดอลลาร์ เท่ากับ 35 บาทครับ",
    vietnamese: "1 Đô la bằng 35 Baht.",
    scenario: "Đổi tiền",
  },
  {
    id: 143,
    role: "A",
    speaker: "Du khách",
    thai: "ฉันต้องการแลก 100 ดอลลาร์",
    vietnamese: "Tôi muốn đổi 100 Đô la.",
    scenario: "Đổi tiền",
  },
  {
    id: 144,
    role: "B",
    speaker: "Nhân viên",
    thai: "ขอพาสปอร์ตด้วยครับ",
    vietnamese: "Cho xin hộ chiếu ạ.",
    scenario: "Đổi tiền",
  },
  {
    id: 145,
    role: "A",
    speaker: "Du khách",
    thai: "ขอแบงค์ย่อยด้วยได้ไหม?",
    vietnamese: "Cho tôi tiền lẻ được không?",
    scenario: "Đổi tiền",
  },
  {
    id: 146,
    role: "B",
    speaker: "Nhân viên",
    thai: "ได้ครับ นี่ครับใบเสร็จ",
    vietnamese: "Được ạ. Đây là hóa đơn.",
    scenario: "Đổi tiền",
  },
  {
    id: 147,
    role: "A",
    speaker: "Du khách",
    thai: "ตู้ ATM อยู่ไหน?",
    vietnamese: "Cây ATM ở đâu?",
    scenario: "Đổi tiền",
  },
  {
    id: 148,
    role: "B",
    speaker: "Nhân viên",
    thai: "อยู่หน้าเซเว่นครับ",
    vietnamese: "Ở trước cửa 7-Eleven.",
    scenario: "Đổi tiền",
  },
  {
    id: 149,
    role: "A",
    speaker: "Du khách",
    thai: "บัตรนี้กดเงินได้ไหม?",
    vietnamese: "Thẻ này rút tiền được không?",
    scenario: "Đổi tiền",
  },
  {
    id: 150,
    role: "B",
    speaker: "Nhân viên",
    thai: "ได้ครับ แต่มีค่าธรรมเนียม",
    vietnamese: "Được, nhưng có phí giao dịch.",
    scenario: "Đổi tiền",
  },

  // =================================================================
  // SCENARIO 17: MẶC CẢ (BARGAINING)
  // =================================================================
  {
    id: 151,
    role: "A",
    speaker: "Khách",
    thai: "เสื้อตัวนี้สวยจัง",
    vietnamese: "Cái áo này đẹp quá.",
    scenario: "Mặc cả",
  },
  {
    id: 152,
    role: "A",
    speaker: "Khách",
    thai: "มีไซส์ใหญ่กว่านี้ไหม?",
    vietnamese: "Có size to hơn không?",
    scenario: "Mặc cả",
  },
  {
    id: 153,
    role: "B",
    speaker: "Chủ quán",
    thai: "มีครับ ไซส์ XL ลองได้นะ",
    vietnamese: "Có size XL, thử được nhé.",
    scenario: "Mặc cả",
  },
  {
    id: 154,
    role: "A",
    speaker: "Khách",
    thai: "ถ้าซื้อ 2 ตัว ลดได้ไหม?",
    vietnamese: "Nếu mua 2 cái có giảm giá không?",
    scenario: "Mặc cả",
  },
  {
    id: 155,
    role: "B",
    speaker: "Chủ quán",
    thai: "ลดให้เหลือ 500 ถ้วนละกัน",
    vietnamese: "Giảm còn tròn 500 nhé.",
    scenario: "Mặc cả",
  },
  {
    id: 156,
    role: "A",
    speaker: "Khách",
    thai: "400 ได้ไหม? นะๆ",
    vietnamese: "400 được không? Đi mà...",
    scenario: "Mặc cả",
  },
  {
    id: 157,
    role: "B",
    speaker: "Chủ quán",
    thai: "ไม่ได้จริงๆ ต้นทุนมาแพง",
    vietnamese: "Không được thật mà, giá vốn cao lắm.",
    scenario: "Mặc cả",
  },
  {
    id: 158,
    role: "A",
    speaker: "Khách",
    thai: "งั้นไม่เอาครับ ขอบคุณ",
    vietnamese: "Thế thôi không lấy, cảm ơn.",
    scenario: "Mặc cả",
  },
  {
    id: 159,
    role: "B",
    speaker: "Chủ quán",
    thai: "โอเคๆ 450 ก็ได้",
    vietnamese: "Ok ok, 450 cũng được.",
    scenario: "Mặc cả",
  },
  {
    id: 160,
    role: "A",
    speaker: "Khách",
    thai: "ขอบคุณครับ",
    vietnamese: "Cảm ơn nhé.",
    scenario: "Mặc cả",
  },

  // =================================================================
  // SCENARIO 18: ĐI BAR / CLUB (NIGHTLIFE)
  // =================================================================
  {
    id: 161,
    role: "A",
    speaker: "Nam",
    thai: "ขอเบียร์ช้างขวดใหญ่",
    vietnamese: "Cho 1 chai bia Chang lớn.",
    scenario: "Bar/Pub",
  },
  {
    id: 162,
    role: "B",
    speaker: "Phục vụ",
    thai: "เอาน้ำแข็งไหม?",
    vietnamese: "Có lấy đá không?",
    scenario: "Bar/Pub",
  },
  {
    id: 163,
    role: "A",
    speaker: "Nam",
    thai: "เอาครับ 1 ถัง",
    vietnamese: "Lấy 1 xô đá nhé.",
    scenario: "Bar/Pub",
  },
  {
    id: 164,
    role: "A",
    speaker: "Nam",
    thai: "ชนแก้ว!",
    vietnamese: "Cụng ly nào! (Dô!)",
    scenario: "Bar/Pub",
  },
  {
    id: 165,
    role: "A",
    speaker: "Nam",
    thai: "เพลงนี้มันส์มาก",
    vietnamese: "Bài này sung quá (Nhạc hay quá).",
    scenario: "Bar/Pub",
  },
  {
    id: 166,
    role: "A",
    speaker: "Nam",
    thai: "สาวโต๊ะนั้นน่ารัก",
    vietnamese: "Cô gái bàn kia dễ thương thế.",
    scenario: "Bar/Pub",
  },
  {
    id: 167,
    role: "A",
    speaker: "Nam",
    thai: "ไปขอไลน์ได้ไหม?",
    vietnamese: "Qua xin Line được không nhỉ?",
    scenario: "Bar/Pub",
  },
  {
    id: 168,
    role: "B",
    speaker: "Bạn",
    thai: "ระวังแฟนเขามาเห็นนะ",
    vietnamese: "Cẩn thận người yêu nó thấy đấy.",
    scenario: "Bar/Pub",
  },
  {
    id: 169,
    role: "A",
    speaker: "Nam",
    thai: "ยังไม่เมาครับ",
    vietnamese: "Tôi vẫn chưa say mà.",
    scenario: "Bar/Pub",
  },
  {
    id: 170,
    role: "B",
    speaker: "Phục vụ",
    thai: "ร้านปิดตี 2 นะครับ",
    vietnamese: "Quán đóng cửa lúc 2h sáng nhé.",
    scenario: "Bar/Pub",
  },

  // =================================================================
  // SCENARIO 19: GỌI XE CÔNG NGHỆ (GRAB/BOLT)
  // =================================================================
  {
    id: 171,
    role: "A",
    speaker: "Tài xế",
    thai: "สวัสดีครับ ผมถึงแล้วครับ",
    vietnamese: "Alo, tôi đến rồi.",
    scenario: "Gọi xe",
  },
  {
    id: 172,
    role: "B",
    speaker: "Khách",
    thai: "รอแป๊บนึงครับ กำลังลงไป",
    vietnamese: "Đợi chút, tôi đang xuống.",
    scenario: "Gọi xe",
  },
  {
    id: 173,
    role: "A",
    speaker: "Tài xế",
    thai: "คุณใส่เสื้อสีอะไร?",
    vietnamese: "Bạn mặc áo màu gì?",
    scenario: "Gọi xe",
  },
  {
    id: 174,
    role: "B",
    speaker: "Khách",
    thai: "สีขาวครับ ยืนอยู่หน้าเซเว่น",
    vietnamese: "Màu trắng, đứng trước 7-Eleven.",
    scenario: "Gọi xe",
  },
  {
    id: 175,
    role: "A",
    speaker: "Tài xế",
    thai: "โอเคครับ เห็นแล้วครับ",
    vietnamese: "Ok thấy rồi.",
    scenario: "Gọi xe",
  },
  {
    id: 176,
    role: "B",
    speaker: "Khách",
    thai: "ขึ้นทางด่วนไหมครับ?",
    vietnamese: "Có đi đường cao tốc không?",
    scenario: "Gọi xe",
  },
  {
    id: 177,
    role: "A",
    speaker: "Tài xế",
    thai: "ขึ้นดีกว่าครับ รถติด",
    vietnamese: "Nên đi, đường tắc lắm.",
    scenario: "Gọi xe",
  },
  {
    id: 178,
    role: "B",
    speaker: "Khách",
    thai: "ค่าทางด่วนใครจ่าย?",
    vietnamese: "Phí cao tốc ai trả?",
    scenario: "Gọi xe",
  },
  {
    id: 179,
    role: "A",
    speaker: "Tài xế",
    thai: "ลูกค้าจ่ายครับ",
    vietnamese: "Khách trả ạ.",
    scenario: "Gọi xe",
  },
  {
    id: 180,
    role: "B",
    speaker: "Khách",
    thai: "เลี้ยวขวาข้างหน้าครับ",
    vietnamese: "Rẽ phải phía trước.",
    scenario: "Gọi xe",
  },

  // =================================================================
  // SCENARIO 20: HẸN HÒ (DATING)
  // =================================================================
  {
    id: 181,
    role: "A",
    speaker: "Nam",
    thai: "คืนนี้ว่างไหม?",
    vietnamese: "Tối nay rảnh không?",
    scenario: "Hẹn hò",
  },
  {
    id: 182,
    role: "B",
    speaker: "Nữ",
    thai: "ว่างค่ะ ทำไมเหรอ?",
    vietnamese: "Rảnh ạ. Sao thế?",
    scenario: "Hẹn hò",
  },
  {
    id: 183,
    role: "A",
    speaker: "Nam",
    thai: "ไปดูหนังกันไหม?",
    vietnamese: "Đi xem phim không?",
    scenario: "Hẹn hò",
  },
  {
    id: 184,
    role: "B",
    speaker: "Nữ",
    thai: "ไปสิคะ เรื่องอะไรดี?",
    vietnamese: "Đi chứ. Xem phim gì?",
    scenario: "Hẹn hò",
  },
  {
    id: 185,
    role: "A",
    speaker: "Nam",
    thai: "หนังผีไหม?",
    vietnamese: "Phim ma nhé?",
    scenario: "Hẹn hò",
  },
  {
    id: 186,
    role: "B",
    speaker: "Nữ",
    thai: "กลัวผีค่ะ ไม่เอา",
    vietnamese: "Sợ ma lắm, không xem đâu.",
    scenario: "Hẹn hò",
  },
  {
    id: 187,
    role: "A",
    speaker: "Nam",
    thai: "งั้นหนังตลกละกัน",
    vietnamese: "Vậy phim hài nhé.",
    scenario: "Hẹn hò",
  },
  {
    id: 188,
    role: "B",
    speaker: "Nữ",
    thai: "โอเคค่ะ เจอกันกี่โมง?",
    vietnamese: "Ok. Gặp nhau mấy giờ?",
    scenario: "Hẹn hò",
  },
  {
    id: 189,
    role: "A",
    speaker: "Nam",
    thai: "1 ทุ่ม ที่สยามพารากอน",
    vietnamese: "7h tối ở Siam Paragon.",
    scenario: "Hẹn hò",
  },
  {
    id: 190,
    role: "A",
    speaker: "Nam",
    thai: "คิดถึงนะ",
    vietnamese: "Nhớ em nha.",
    scenario: "Hẹn hò",
  },

  // =================================================================
  // SCENARIO 21: TRƯỜNG HỌC (SCHOOL)
  // =================================================================
  {
    id: 191,
    role: "A",
    speaker: "Học sinh A",
    thai: "ทำการบ้านเสร็จยัง?",
    vietnamese: "Làm bài tập xong chưa?",
    scenario: "Trường học",
  },
  {
    id: 192,
    role: "B",
    speaker: "Học sinh B",
    thai: "ยังเลย ยากมาก",
    vietnamese: "Chưa, khó quá.",
    scenario: "Trường học",
  },
  {
    id: 193,
    role: "A",
    speaker: "Học sinh A",
    thai: "ขอลอกหน่อยสิ",
    vietnamese: "Cho chép tí đi.",
    scenario: "Trường học",
  },
  {
    id: 194,
    role: "B",
    speaker: "Học sinh B",
    thai: "ไม่ได้ เดี๋ยวครูด่า",
    vietnamese: "Không được, tí cô mắng.",
    scenario: "Trường học",
  },
  {
    id: 195,
    role: "A",
    speaker: "Học sinh A",
    thai: "วันนี้เลิกเรียนกี่โมง?",
    vietnamese: "Hôm nay mấy giờ tan học?",
    scenario: "Trường học",
  },
  {
    id: 196,
    role: "B",
    speaker: "Học sinh B",
    thai: "บ่าย 3 โมง",
    vietnamese: "3 giờ chiều.",
    scenario: "Trường học",
  },
  {
    id: 197,
    role: "A",
    speaker: "Học sinh A",
    thai: "ไปกินไอติมกันไหม?",
    vietnamese: "Đi ăn kem không?",
    scenario: "Trường học",
  },
  {
    id: 198,
    role: "B",
    speaker: "Học sinh B",
    thai: "ไปๆ หิวพอดี",
    vietnamese: "Đi đi, đang đói.",
    scenario: "Trường học",
  },
  {
    id: 199,
    role: "A",
    speaker: "GV",
    thai: "ตั้งใจเรียนนะ",
    vietnamese: "Tập trung học đi nhé.",
    scenario: "Trường học",
  },
  {
    id: 200,
    role: "B",
    speaker: "Học sinh",
    thai: "ครับ/ค่ะ คุณครู",
    vietnamese: "Vâng ạ thưa cô.",
    scenario: "Trường học",
  },

  // =================================================================
  // SCENARIO 22: CÔNG SỞ (OFFICE)
  // =================================================================
  {
    id: 201,
    role: "A",
    speaker: "Đồng nghiệp",
    thai: "ประชุมกี่โมง?",
    vietnamese: "Mấy giờ họp?",
    scenario: "Công sở",
  },
  {
    id: 202,
    role: "B",
    speaker: "Đồng nghiệp",
    thai: "10 โมงเช้า ที่ห้องใหญ่",
    vietnamese: "10h sáng ở phòng lớn.",
    scenario: "Công sở",
  },
  {
    id: 203,
    role: "A",
    speaker: "Đồng nghiệp",
    thai: "เจ้านายมาหรือยัง?",
    vietnamese: "Sếp đến chưa?",
    scenario: "Công sở",
  },
  {
    id: 204,
    role: "B",
    speaker: "Đồng nghiệp",
    thai: "มาแล้ว อารมณ์ไม่ดีด้วย",
    vietnamese: "Đến rồi, tâm trạng không tốt đâu.",
    scenario: "Công sở",
  },
  {
    id: 205,
    role: "A",
    speaker: "Đồng nghiệp",
    thai: "งานเสร็จทันไหม?",
    vietnamese: "Xong việc kịp không?",
    scenario: "Công sở",
  },
  {
    id: 206,
    role: "B",
    speaker: "Đồng nghiệp",
    thai: "ไม่ทันแน่ๆ ต้องทำโอที",
    vietnamese: "Chắc chắn không kịp, phải OT rồi.",
    scenario: "Công sở",
  },
  {
    id: 207,
    role: "A",
    speaker: "Đồng nghiệp",
    thai: "เงินเดือนออกวันไหน?",
    vietnamese: "Ngày nào có lương?",
    scenario: "Công sở",
  },
  {
    id: 208,
    role: "B",
    speaker: "Đồng nghiệp",
    thai: "วันศุกร์นี้แหละ",
    vietnamese: "Thứ 6 này đấy.",
    scenario: "Công sở",
  },
  {
    id: 209,
    role: "A",
    speaker: "Đồng nghiệp",
    thai: "เที่ยงนี้กินอะไรดี?",
    vietnamese: "Trưa nay ăn gì nhỉ?",
    scenario: "Công sở",
  },
  {
    id: 210,
    role: "B",
    speaker: "Đồng nghiệp",
    thai: "ก๋วยเตี๋ยวหน้าตึกไหม",
    vietnamese: "Hủ tiếu trước tòa nhà nhé.",
    scenario: "Công sở",
  },

  // =================================================================
  // SCENARIO 23: CẮT TÓC (BARBER SHOP)
  // =================================================================
  {
    id: 211,
    role: "A",
    speaker: "Khách",
    thai: "ตัดผมครับ",
    vietnamese: "Cắt tóc ạ.",
    scenario: "Cắt tóc",
  },
  {
    id: 212,
    role: "B",
    speaker: "Thợ",
    thai: "เอาทรงไหนครับ?",
    vietnamese: "Lấy kiểu nào?",
    scenario: "Cắt tóc",
  },
  {
    id: 213,
    role: "A",
    speaker: "Khách",
    thai: "เอาออกนิดเดียวครับ",
    vietnamese: "Cắt bớt một chút thôi.",
    scenario: "Cắt tóc",
  },
  {
    id: 214,
    role: "A",
    speaker: "Khách",
    thai: "ข้างหลังสั้นๆ ครับ",
    vietnamese: "Đằng sau cắt ngắn nhé.",
    scenario: "Cắt tóc",
  },
  {
    id: 215,
    role: "B",
    speaker: "Thợ",
    thai: "สระผมด้วยไหม?",
    vietnamese: "Có gội đầu không?",
    scenario: "Cắt tóc",
  },
  {
    id: 216,
    role: "A",
    speaker: "Khách",
    thai: "สระด้วยครับ",
    vietnamese: "Có gội ạ.",
    scenario: "Cắt tóc",
  },
  {
    id: 217,
    role: "B",
    speaker: "Thợ",
    thai: "น้ำอุ่นหรือน้ำเย็น?",
    vietnamese: "Nước ấm hay nước lạnh?",
    scenario: "Cắt tóc",
  },
  {
    id: 218,
    role: "A",
    speaker: "Khách",
    thai: "น้ำเย็นครับ สดชื่นดี",
    vietnamese: "Nước lạnh đi, cho sảng khoái.",
    scenario: "Cắt tóc",
  },
  {
    id: 219,
    role: "B",
    speaker: "Thợ",
    thai: "เสร็จแล้วครับ ชอบไหม?",
    vietnamese: "Xong rồi. Thích không?",
    scenario: "Cắt tóc",
  },
  {
    id: 220,
    role: "A",
    speaker: "Khách",
    thai: "ชอบครับ หล่อเลย",
    vietnamese: "Thích ạ. Đẹp trai luôn.",
    scenario: "Cắt tóc",
  },

  // =================================================================
  // SCENARIO 24: CHỤP ẢNH GIÚP (ASKING FOR PHOTOS)
  // =================================================================
  {
    id: 221,
    role: "A",
    speaker: "Du khách",
    thai: "ขอโทษครับ ช่วยถ่ายรูปให้หน่อยได้ไหม?",
    vietnamese: "Xin lỗi, chụp giúp tôi kiểu ảnh được không?",
    scenario: "Chụp ảnh",
  },
  {
    id: 222,
    role: "B",
    speaker: "Người qua đường",
    thai: "ได้ครับ",
    vietnamese: "Được chứ.",
    scenario: "Chụp ảnh",
  },
  {
    id: 223,
    role: "A",
    speaker: "Du khách",
    thai: "กดปุ่มนี้ครับ",
    vietnamese: "Ấn nút này nhé.",
    scenario: "Chụp ảnh",
  },
  {
    id: 224,
    role: "A",
    speaker: "Du khách",
    thai: "ขอแนวตั้งรูปนึงครับ",
    vietnamese: "Cho xin 1 tấm dọc nhé.",
    scenario: "Chụp ảnh",
  },
  {
    id: 225,
    role: "A",
    speaker: "Du khách",
    thai: "ขออีกรูปครับ",
    vietnamese: "Xin thêm tấm nữa.",
    scenario: "Chụp ảnh",
  },
  {
    id: 226,
    role: "B",
    speaker: "Người qua đường",
    thai: "รูปสวยมากครับ",
    vietnamese: "Ảnh đẹp lắm.",
    scenario: "Chụp ảnh",
  },
  {
    id: 227,
    role: "A",
    speaker: "Du khách",
    thai: "ขอบคุณมากครับ",
    vietnamese: "Cảm ơn nhiều ạ.",
    scenario: "Chụp ảnh",
  },
  {
    id: 228,
    role: "A",
    speaker: "Du khách",
    thai: "ให้ผมถ่ายให้คุณไหม?",
    vietnamese: "Tôi chụp cho bạn nhé?",
    scenario: "Chụp ảnh",
  },
  {
    id: 229,
    role: "B",
    speaker: "Người qua đường",
    thai: "ไม่เป็นไรครับ ขอบคุณ",
    vietnamese: "Không cần đâu, cảm ơn.",
    scenario: "Chụp ảnh",
  },
  {
    id: 230,
    role: "A",
    speaker: "Du khách",
    thai: "วิวตรงนี้สวย",
    vietnamese: "Cảnh ở đây đẹp thật.",
    scenario: "Chụp ảnh",
  },

  // =================================================================
  // SCENARIO 25: ĐI CHÙA (TEMPLE)
  // =================================================================
  {
    id: 231,
    role: "A",
    speaker: "Du khách",
    thai: "เข้าวัดต้องแต่งตัวยังไง?",
    vietnamese: "Vào chùa phải mặc như thế nào?",
    scenario: "Đi chùa",
  },
  {
    id: 232,
    role: "B",
    speaker: "Hướng dẫn",
    thai: "ห้ามใส่กางเกงขาสั้น",
    vietnamese: "Cấm mặc quần đùi.",
    scenario: "Đi chùa",
  },
  {
    id: 233,
    role: "A",
    speaker: "Du khách",
    thai: "ถอดรองเท้าไหม?",
    vietnamese: "Có phải cởi giày không?",
    scenario: "Đi chùa",
  },
  {
    id: 234,
    role: "B",
    speaker: "Hướng dẫn",
    thai: "ต้องถอดครับ",
    vietnamese: "Phải cởi ạ.",
    scenario: "Đi chùa",
  },
  {
    id: 235,
    role: "A",
    speaker: "Du khách",
    thai: "ซื้อดอกไม้ธูปเทียนที่ไหน?",
    vietnamese: "Mua hoa và hương nến ở đâu?",
    scenario: "Đi chùa",
  },
  {
    id: 236,
    role: "B",
    speaker: "Hướng dẫn",
    thai: "ด้านหน้าครับ ชุดละ 20 บาท",
    vietnamese: "Ở phía trước, 20 Baht một bộ.",
    scenario: "Đi chùa",
  },
  {
    id: 237,
    role: "A",
    speaker: "Du khách",
    thai: "ถ่ายรูปได้ไหม?",
    vietnamese: "Có được chụp ảnh không?",
    scenario: "Đi chùa",
  },
  {
    id: 238,
    role: "B",
    speaker: "Hướng dẫn",
    thai: "ได้ครับ แต่ห้ามใช้แฟลช",
    vietnamese: "Được nhưng cấm dùng đèn flash.",
    scenario: "Đi chùa",
  },
  {
    id: 239,
    role: "A",
    speaker: "Du khách",
    thai: "พระสวยมาก",
    vietnamese: "Tượng Phật đẹp quá.",
    scenario: "Đi chùa",
  },
  {
    id: 240,
    role: "B",
    speaker: "Hướng dẫn",
    thai: "เงียบๆ นะครับ",
    vietnamese: "Giữ trật tự nhé.",
    scenario: "Đi chùa",
  },

  // =================================================================
  // SCENARIO 26: SỬA XE (REPAIR)
  // =================================================================
  {
    id: 241,
    role: "A",
    speaker: "Khách",
    thai: "รถสตาร์ทไม่ติด",
    vietnamese: "Xe không nổ máy.",
    scenario: "Sửa xe",
  },
  {
    id: 242,
    role: "B",
    speaker: "Thợ",
    thai: "แบตหมดหรือเปล่า?",
    vietnamese: "Có phải hết bình (ắc quy) không?",
    scenario: "Sửa xe",
  },
  {
    id: 243,
    role: "A",
    speaker: "Khách",
    thai: "ยางรั่วครับ",
    vietnamese: "Xe bị thủng lốp.",
    scenario: "Sửa xe",
  },
  {
    id: 244,
    role: "B",
    speaker: "Thợ",
    thai: "ปะยาง 50 บาท",
    vietnamese: "Vá lốp 50 Baht.",
    scenario: "Sửa xe",
  },
  {
    id: 245,
    role: "A",
    speaker: "Khách",
    thai: "เปลี่ยนยางใหม่เท่าไหร่?",
    vietnamese: "Thay lốp mới bao nhiêu?",
    scenario: "Sửa xe",
  },
  {
    id: 246,
    role: "B",
    speaker: "Thợ",
    thai: "300 บาทครับ",
    vietnamese: "300 Baht ạ.",
    scenario: "Sửa xe",
  },
  {
    id: 247,
    role: "A",
    speaker: "Khách",
    thai: "นานไหมครับ?",
    vietnamese: "Có lâu không?",
    scenario: "Sửa xe",
  },
  {
    id: 248,
    role: "B",
    speaker: "Thợ",
    thai: "10 นาทีครับ",
    vietnamese: "10 phút thôi.",
    scenario: "Sửa xe",
  },
  {
    id: 249,
    role: "A",
    speaker: "Khách",
    thai: "ช่วยเช็คเบรคด้วย",
    vietnamese: "Kiểm tra phanh giúp tôi luôn.",
    scenario: "Sửa xe",
  },
  {
    id: 250,
    role: "B",
    speaker: "Thợ",
    thai: "ได้ครับ",
    vietnamese: "Được ạ.",
    scenario: "Sửa xe",
  },

  // =================================================================
  // SCENARIO 27: NGÂN HÀNG (BANK)
  // =================================================================
  {
    id: 251,
    role: "A",
    speaker: "Khách",
    thai: "อยากเปิดบัญชีใหม่ครับ",
    vietnamese: "Tôi muốn mở tài khoản mới.",
    scenario: "Ngân hàng",
  },
  {
    id: 252,
    role: "B",
    speaker: "Nhân viên",
    thai: "เตรียมเอกสารมาครบไหมคะ?",
    vietnamese: "Chuẩn bị đủ giấy tờ chưa ạ?",
    scenario: "Ngân hàng",
  },
  {
    id: 253,
    role: "A",
    speaker: "Khách",
    thai: "มีพาสปอร์ตกับเวิร์คเพอร์มิต",
    vietnamese: "Có hộ chiếu và giấy phép lao động.",
    scenario: "Ngân hàng",
  },
  {
    id: 254,
    role: "B",
    speaker: "Nhân viên",
    thai: "เซ็นชื่อตรงนี้ค่ะ",
    vietnamese: "Ký tên vào đây ạ.",
    scenario: "Ngân hàng",
  },
  {
    id: 255,
    role: "A",
    speaker: "Khách",
    thai: "โอนเงินไปต่างประเทศได้ไหม?",
    vietnamese: "Chuyển tiền ra nước ngoài được không?",
    scenario: "Ngân hàng",
  },
  {
    id: 256,
    role: "B",
    speaker: "Nhân viên",
    thai: "ได้ค่ะ ผ่านแอปพลิเคชัน",
    vietnamese: "Được ạ, qua ứng dụng.",
    scenario: "Ngân hàng",
  },
  {
    id: 257,
    role: "A",
    speaker: "Khách",
    thai: "บัตรหาย ต้องทำไง?",
    vietnamese: "Mất thẻ thì phải làm sao?",
    scenario: "Ngân hàng",
  },
  {
    id: 258,
    role: "B",
    speaker: "Nhân viên",
    thai: "ต้องอายัดบัตรก่อนค่ะ",
    vietnamese: "Phải khóa thẻ trước ạ.",
    scenario: "Ngân hàng",
  },
  {
    id: 259,
    role: "A",
    speaker: "Khách",
    thai: "ค่าธรรมเนียมเท่าไหร่?",
    vietnamese: "Phí bao nhiêu?",
    scenario: "Ngân hàng",
  },
  {
    id: 260,
    role: "B",
    speaker: "Nhân viên",
    thai: "100 บาทค่ะ",
    vietnamese: "100 Baht ạ.",
    scenario: "Ngân hàng",
  },

  // =================================================================
  // SCENARIO 28: ĐỜI SỐNG HÀNG NGÀY (DAILY LIFE)
  // =================================================================
  {
    id: 261,
    role: "A",
    speaker: "Bạn A",
    thai: "กินข้าวหรือยัง?",
    vietnamese: "Ăn cơm chưa?",
    scenario: "Đời sống",
  },
  {
    id: 262,
    role: "B",
    speaker: "Bạn B",
    thai: "ยังเลย หิวมาก",
    vietnamese: "Chưa, đói lắm.",
    scenario: "Đời sống",
  },
  {
    id: 263,
    role: "A",
    speaker: "Bạn A",
    thai: "ไปกินส้มตำกัน",
    vietnamese: "Đi ăn Som Tam đi.",
    scenario: "Đời sống",
  },
  {
    id: 264,
    role: "B",
    speaker: "Bạn B",
    thai: "ไม่เอา เผ็ด",
    vietnamese: "Thôi, cay lắm.",
    scenario: "Đời sống",
  },
  {
    id: 265,
    role: "A",
    speaker: "Bạn A",
    thai: "งั้นไปกินข้าวมันไก่",
    vietnamese: "Thế đi ăn cơm gà.",
    scenario: "Đời sống",
  },
];
